function setCookie(name, value, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/; SameSite=Strict`;
}

function getCookie(name) {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
            try {
                return JSON.parse(cookie.substring(cookieName.length, cookie.length));
            } catch (e) {
                return null;
            }
        }
    }
    return null;
}

function removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function safeRemoveEventListener(element, event, handler) {
    if (element) {
        element.removeEventListener(event, handler);
    }
}

function validateFileInput(fileInput) {
    if (!fileInput.files || fileInput.files.length === 0) {
        return false;
    }
    const file = fileInput.files[0];
    if (!file || !file.type || !file.size) {
        return false;
    }
    if (!file.type.match('image.*')) {
        return false;
    }
    if (file.size > 10 * 1024 * 1024) {
        return false;
    }
    return true;
}

// PDP Personalization Form Component
document.addEventListener("DOMContentLoaded", () => {

    if (!localStorage.getItem('formData')) {
        localStorage.removeItem('bundleBody');
    }

    const tabs = document.querySelectorAll("[id^=tab-]");
    const forms = {
        "tab-name": document.getElementById("form-primary"),
        "tab-icon": document.getElementById("form-secondary"),
        "tab-both": document.getElementById("form-tertiary"),
    };

    forms["tab-name"].classList.remove("tw-hidden");
    document.getElementById("tab-name").classList.remove("color_E6E6E6");
    document.getElementById("tab-name").classList.add("color_C8C8CA");

    tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
            Object.values(forms).forEach(form => form.classList.add("tw-hidden"));

            forms[tab.id].classList.remove("tw-hidden");
            forms[tab.id].classList.add("tw-transition-opacity", "tw-duration-300", "tw-opacity-0");
            forms[tab.id].offsetHeight;
            forms[tab.id].classList.remove("tw-opacity-0");
            forms[tab.id].classList.add("tw-opacity-100");

            if (forms[tab.id].id === 'form-secondary') {
                const rangePrice = document.getElementById('secondary-form-price');
                rangePrice.textContent = rangePrice.dataset.formPrice;
            }

            if (forms[tab.id].id === 'form-tertiary') {
                const rangePrice = document.getElementById('tertiary-form-price');
                rangePrice.textContent = rangePrice.dataset.formPrice;
            }

            tabs.forEach(tab => tab.classList.remove("color_C8C8CA"));
            tabs.forEach(tab => tab.classList.add("color_E6E6E6"));

            tab.classList.add("color_C8C8CA");
            tab.classList.remove("color_E6E6E6");
        })
    })

    // ===== PRIMARY "Name" FIELD BLUR VALIDATION =====
    // Embroidery flow (top/bottom split) uses #top-name / #bottom-name.
    // Caps flow (fixed single placement) uses .primary_name (#name).
    const topNameField = document.getElementById('top-name');
    const bottomNameField = document.getElementById('bottom-name');
    const primaryNameField = document.querySelector('.primary_name');

    if (topNameField) {
        topNameField.addEventListener('blur', () => {
            const placementSelect = document.getElementById('text-placement-select');
            if (placementSelect && placementSelect.value === 'bottom-only') return;
            if (topNameField.value == '') {
                document.querySelector('#top-name-error')?.classList.remove('tw-hidden');
            } else {
                document.querySelector('#top-name-error')?.classList.add('tw-hidden');
            }
        })
    } else if (primaryNameField) {
        primaryNameField.addEventListener('blur', () => {
            if (primaryNameField.value == '') {
                document.querySelector('#primary-error-message')?.classList.remove('tw-hidden');
            } else {
                document.querySelector('#primary-error-message')?.classList.add('tw-hidden');
            }
        })
    }

    if (bottomNameField) {
        bottomNameField.addEventListener('blur', () => {
            const placementSelect = document.getElementById('text-placement-select');
            if (placementSelect && placementSelect.value === 'top-only') return;
            if (bottomNameField.value == '') {
                document.querySelector('#bottom-name-error')?.classList.remove('tw-hidden');
            } else {
                document.querySelector('#bottom-name-error')?.classList.add('tw-hidden');
            }
        })
    }

    // ===== TERTIARY "Name and Icon" FIELD BLUR VALIDATION =====
    // Embroidery flow uses #tertiary-top-name (error: #tertiary-top-name-error).
    // Caps flow uses #name inside .tertiary__form (error: #tertiary-error-message).
    const tertiaryName = document.querySelector('.tertiary_name');

    if (tertiaryName) {
        tertiaryName.addEventListener('blur', () => {
            const placementSelect = document.getElementById('tertiary-text-placement-select');
            if (placementSelect && placementSelect.value === 'bottom-only') return;
            const errorEl = document.querySelector('#tertiary-top-name-error') || document.querySelector('#tertiary-error-message');
            if (tertiaryName.value == '') {
                errorEl?.classList.remove('tw-hidden');
            } else {
                errorEl?.classList.add('tw-hidden');
            }
        })
    }

});


function attachEventListeners() {
    const fileInput = document.getElementById('property-custom-icon');
    const fileInputLabel = document.getElementById('upload-label');
    const fileDisclaimer = document.getElementById('file-disclaimer');
    const labelAbbr = document.getElementById('label-abbr');
    let dataValue = fileInputLabel.dataset.labelValue;
    if (fileInput) {
        fileInput.addEventListener('change', () => {
            if (fileInput.files.length > 0) {
                let fileName = fileInput.files[0].name;
                labelAbbr.title = fileName;
                fileInputLabel.textContent = fileName;
                fileDisclaimer.textContent = 'File Uploaded Successfully';
                fileDisclaimer.style.fontWeight = 'bold';
            }
            else {
                fileInputLabel.textContent = dataValue;
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
            }
        })
    }
}

class PersonalizeButton extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.addEventListener('click', this.openModel.bind(this));
        if (document.getElementById('close-model')) {
            document.getElementById('close-model').addEventListener('click', this.closeModel.bind(this));
        }
        if (document.getElementById('edit-model-open')) {
            document.getElementById('edit-model-open').addEventListener('click', this.openModel.bind(this));
        }
    }

    openModel() {
        document.querySelector("#dialog-backdrop").classList.remove("pointer-events-none", "opacity-0");
        document.querySelector("#data-dialog").classList.remove("opacity-0", "-translate-y-14");
        document.querySelector("#data-dialog").classList.add("opacity-1", "translate-y-0");
        document.body.classList.add('tw-overflow-hidden');
    }
    closeModel() {
        document.querySelector("#dialog-backdrop").classList.add("pointer-events-none", "opacity-0");
        document.querySelector("#data-dialog").classList.remove("opacity-1", "translate-y-0");
        document.querySelector("#data-dialog").classList.add("opacity-0", "-translate-y-14");
        document.body.classList.remove('tw-overflow-hidden');
        document.body.classList.add('tw-overflow-none');
    }
}

customElements.define('personalize-button', PersonalizeButton);

class ColorPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const colorInputs = this.querySelectorAll('.color-input');
        const colorLabels = this.querySelectorAll('.color-label');
        const selectedColorSpan = this.querySelector('#selected-color');

        selectedColorSpan.textContent = '';

        colorInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedColorSpan.textContent = input.value;
                const colorError = document.querySelector("#primary-color-error");
                if (colorError) {
                    colorError.classList.add('tw-hidden');
                }
                colorLabels.forEach(label => {
                    label.style.border = 0;
                    label.style.padding = 0;
                    label.style.width = '3.2rem';
                    label.style.height = '1.6rem';
                    label.style.outline = 'none';
                });
                colorLabels[index].style.border = '0.1rem solid #f8f6f3';
                colorLabels[index].style.outline = 'solid';
                colorLabels[index].style.outlineWidth = '0.2rem';
                colorLabels[index].style.outlineColor = '#808080';
            });
        });
    }
}

customElements.define('color-picker', ColorPicker);

class TertiaryColorPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const colorInputs = this.querySelectorAll('.tertiary-color-input');
        const colorLabels = this.querySelectorAll('.tertiary-color-label');
        const selectedColorSpan = this.querySelector('#selected-color');

        selectedColorSpan.textContent = '';

        colorInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedColorSpan.textContent = input.value;
                const colorError = document.querySelector("#tertiary-color-error");
                if (colorError) {
                    colorError.classList.add('tw-hidden');
                }
                colorLabels.forEach(label => {
                    label.style.border = 0;
                    label.style.padding = 0;
                    label.style.width = '3.2rem';
                    label.style.height = '1.6rem';
                    label.style.outline = 'none';
                });
                colorLabels[index].style.border = '0.1rem solid #f8f6f3';
                colorLabels[index].style.width = '3.2rem';
                colorLabels[index].style.height = '1.6rem';
                colorLabels[index].style.outline = 'solid';
                colorLabels[index].style.outlineWidth = '0.2rem';
                colorLabels[index].style.outlineColor = '#808080';
            });
        });
    }
}

customElements.define('tertiary-color-picker', TertiaryColorPicker);

class IconPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const iconInputs = this.querySelectorAll('.icon-input');
        const iconLabels = this.querySelectorAll('.icon-label');
        const selectedIconSpan = this.querySelector('#selected-icon');

        initialRadioCheckForIcon(this, selectedIconSpan);

        iconInputs.forEach((input, index) => {
            input.addEventListener('change', (e) => {
                updatePrice(e, 'secondary');

                const iconError = document.querySelector("#secondary-icon-error");
                if (iconError) {
                    iconError.classList.add('tw-hidden');
                }

                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.customIcon = '';
                    formData.previewCustomIcon = '';
                    localStorage.setItem('formData', JSON.stringify(formData));
                    document.getElementById('property-custom-icon').value = '';
                }
                selectedIconSpan.textContent = input.value;
                iconLabels.forEach(label => {
                    label.style.border = '0';
                    label.style.padding = 0;
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                });
                iconLabels[index].style.border = '0.1rem solid #292C35';
                iconLabels[index].style.padding = '0.2rem';
                iconLabels[index].style.width = '4rem';
                iconLabels[index].style.height = '4rem';

                document.querySelector('#property-custom-icon').value = '';
                const fileDisclaimer = document.getElementById('file-disclaimer');
                const uploadLabel = document.getElementById('upload-label');
                const labelAbbr = document.getElementById('label-abbr');
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                fileDisclaimer.style.fontWeight = 'normal';
                labelAbbr.title = '';
                uploadLabel.textContent = uploadLabel.dataset.labelValue;
            });
        });
    }
}
customElements.define('icon-picker', IconPicker);

function updatePrice(e, formName = "") {
    const iconPrice = document.querySelector(`#${formName}-icon-price`).value;
    const customPrice = document.querySelector(`#${formName}-custom-icon-price`).value;
    const updatePrice = document.querySelector(`#${formName}-form-price`);

    if (e.target.type === 'radio') {
        updatePrice.textContent = iconPrice;
    } else {
        updatePrice.textContent = customPrice;
    }
}

document.querySelector('#secondary-property-custom-icon').addEventListener('click', (e) => {
    updatePrice(e, 'secondary');
});

document.querySelector('#tertiary-property-custom-icon').addEventListener('click', (e) => {
    updatePrice(e, 'tertiary');
});


class TertiaryIconPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const iconInputs = this.querySelectorAll('.tertiary-icon-input');
        const iconLabels = this.querySelectorAll('.tertiary-icon-label');
        const selectedIconSpan = this.querySelector('#selected-icon');

        initialRadioCheckForIcon(this, selectedIconSpan);

        iconInputs.forEach((input, index) => {
            input.addEventListener('change', (e) => {
                // window.updateTertiaryPrice only exists on embroidery (top/bottom) tertiary
                // forms — falls back to the plain updatePrice() for caps tertiary forms.
                if (window.updateTertiaryPrice) { window.updateTertiaryPrice('radio'); } else { updatePrice(e, 'tertiary'); }

                const iconError = document.querySelector("#tertiary-icon-error");
                if (iconError) {
                    iconError.classList.add('tw-hidden');
                }

                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.customIcon = '';
                    formData.previewCustomIcon = '';
                    localStorage.setItem('formData', JSON.stringify(formData));
                    document.getElementById('property-custom-icon').value = '';
                }
                selectedIconSpan.textContent = input.value;
                iconLabels.forEach(label => {
                    label.style.border = '0';
                    label.style.padding = 0;
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                });
                iconLabels[index].style.border = '0.1rem solid #292C35';
                iconLabels[index].style.padding = '0.2rem';
                iconLabels[index].style.width = '4rem';
                iconLabels[index].style.height = '4rem';

                document.querySelector('#property-custom-icon').value = '';
                const tertiaryForm = document.querySelector('tertiary-form');
                const fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                const uploadLabel = tertiaryForm.querySelector('#upload-label');
                const labelAbbr = tertiaryForm.querySelector('#label-abbr');
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                fileDisclaimer.style.fontWeight = 'normal';
                labelAbbr.title = '';
                uploadLabel.textContent = uploadLabel.dataset.labelValue;
            });
        });
    }
}

customElements.define('tertiary-icon-picker', TertiaryIconPicker);

class FontPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const fontInputs = this.querySelectorAll('.font-input');
        const fontLabels = this.querySelectorAll('.font-label');
        const selectedFontSpan = this.querySelector('#selected-font');

        initialRadioCheckForFont(this, selectedFontSpan);

        fontInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedFontSpan.textContent = input.value;
                fontLabels.forEach(label => {
                    label.style.border = '0.1rem solid #808080';
                });
                fontLabels[index].style.border = '0.2rem solid #292c35';
            });
        });
    }
}

customElements.define('font-picker', FontPicker);

class TertiaryFontPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const fontInputs = this.querySelectorAll('.tertiary-font-input');
        const fontLabels = this.querySelectorAll('.tertiary-font-label');
        const selectedFontSpan = this.querySelector('#selected-font');

        initialRadioCheckForFont(this, selectedFontSpan);

        fontInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedFontSpan.textContent = input.value;
                fontLabels.forEach(label => {
                    label.style.border = '0.1rem solid #808080';
                });
                fontLabels[index].style.border = '0.2rem solid #292C35';
            });
        });
    }
}

customElements.define('tertiary-font-picker', TertiaryFontPicker);


// ===== VALIDATION =====
// 'Name' and 'Name and Icon' branches detect which flow is active by checking for the
// placement <select> element: present = embroidery (top/bottom), absent = caps (fixed placement).
function validateRequiredFields(formType) {
    let hasErrors = false;

    if (formType === 'Name') {
        const placementSelect = document.getElementById('text-placement-select');
        const colorField = document.querySelector('.primary__form .radio__color input[name="color"]:checked');

        if (placementSelect) {
            // ===== EMBROIDERY FLOW =====
            const placementOption = placementSelect.value;
            const topNameField = document.getElementById('top-name');
            const bottomNameField = document.getElementById('bottom-name');

            const needsTop = placementOption !== 'bottom-only';
            const needsBottom = placementOption !== 'top-only';

            if (needsTop) {
                if (!topNameField || !topNameField.value.trim()) {
                    document.querySelector("#top-name-error")?.classList.remove("tw-hidden");
                    hasErrors = true;
                } else {
                    document.querySelector("#top-name-error")?.classList.add("tw-hidden");
                }
            } else {
                document.querySelector("#top-name-error")?.classList.add("tw-hidden");
            }

            if (needsBottom) {
                if (!bottomNameField || !bottomNameField.value.trim()) {
                    document.querySelector("#bottom-name-error")?.classList.remove("tw-hidden");
                    hasErrors = true;
                } else {
                    document.querySelector("#bottom-name-error")?.classList.add("tw-hidden");
                }
            } else {
                document.querySelector("#bottom-name-error")?.classList.add("tw-hidden");
            }

            if (!colorField) {
                let colorError = document.querySelector("#primary-color-error");
                if (!colorError) {
                    colorError = document.createElement('small');
                    colorError.id = 'primary-color-error';
                    colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                    colorError.textContent = 'Please select a font color';
                    const colorPicker = document.querySelector('.primary__form color-picker');
                    if (colorPicker) {
                        colorPicker.insertAdjacentElement('afterend', colorError);
                    } else {
                        document.querySelector('.primary__form .radio__color').insertAdjacentElement('afterend', colorError);
                    }
                }
                colorError.classList.remove('tw-hidden');
                hasErrors = true;
            } else {
                document.querySelector("#primary-color-error")?.classList.add('tw-hidden');
            }

            if (hasErrors) {
                if (needsTop && (!topNameField || !topNameField.value.trim())) {
                    document.querySelector("#top-name-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
                } else if (needsBottom && (!bottomNameField || !bottomNameField.value.trim())) {
                    document.querySelector("#bottom-name-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
                } else if (!colorField) {
                    document.querySelector("#primary-color-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }

            return !hasErrors;
        }

        // ===== CAPS FLOW (fixed single placement) =====
        const nameField = document.getElementById('name');

        if (!nameField || !nameField.value.trim()) {
            document.querySelector("#primary-error-message")?.classList.remove("tw-hidden");
            hasErrors = true;
        } else {
            document.querySelector("#primary-error-message")?.classList.add("tw-hidden");
        }

        if (!colorField) {
            let colorError = document.querySelector("#primary-color-error");
            if (!colorError) {
                colorError = document.createElement('small');
                colorError.id = 'primary-color-error';
                colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                colorError.textContent = 'Please select a font color';
                const colorPicker = document.querySelector('.primary__form color-picker');
                if (colorPicker) {
                    colorPicker.insertAdjacentElement('afterend', colorError);
                } else {
                    document.querySelector('.primary__form .radio__color').insertAdjacentElement('afterend', colorError);
                }
            }
            colorError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            document.querySelector("#primary-color-error")?.classList.add('tw-hidden');
        }

        if (hasErrors) {
            if (!nameField || !nameField.value.trim()) {
                document.querySelector("#primary-error-message")?.scrollIntoView({ behavior: "smooth", block: "center" });
            } else if (!colorField) {
                document.querySelector("#primary-color-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        return !hasErrors;
    }

    if (formType === 'Name and Icon') {
        const placementSelect = document.getElementById('tertiary-text-placement-select');
        const colorField = document.querySelector('.tertiary__form .radio__color input[name="color"]:checked');
        const selectedIcon = document.querySelector('.tertiary__form input[name="icon"]:checked');
        const customIconInput = document.getElementById('property-custom-icon');
        const hasCustomIcon = customIconInput && customIconInput.files && customIconInput.files.length > 0;

        if (placementSelect) {
            // ===== EMBROIDERY FLOW =====
            const placementOption = placementSelect.value;
            const needsTop = placementOption !== 'bottom-only';
            const needsBottom = placementOption !== 'top-only';

            const topNameField = document.querySelector('.tertiary__form #tertiary-top-name');
            const bottomNameField = document.querySelector('.tertiary__form #tertiary-bottom-name');

            if (needsTop && (!topNameField || !topNameField.value.trim())) {
                document.querySelector('#tertiary-top-name-error')?.classList.remove('tw-hidden');
                hasErrors = true;
            } else {
                document.querySelector('#tertiary-top-name-error')?.classList.add('tw-hidden');
            }

            if (needsBottom && (!bottomNameField || !bottomNameField.value.trim())) {
                document.querySelector('#tertiary-bottom-name-error')?.classList.remove('tw-hidden');
                hasErrors = true;
            } else {
                document.querySelector('#tertiary-bottom-name-error')?.classList.add('tw-hidden');
            }

            if (!colorField) {
                let colorError = document.querySelector("#tertiary-color-error");
                if (!colorError) {
                    colorError = document.createElement('small');
                    colorError.id = 'tertiary-color-error';
                    colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                    colorError.textContent = 'Please select a font color';
                    const tertiaryColorPicker = document.querySelector('.tertiary__form tertiary-color-picker');
                    if (tertiaryColorPicker) {
                        tertiaryColorPicker.insertAdjacentElement('afterend', colorError);
                    } else {
                        document.querySelector('.tertiary__form .radio__color').insertAdjacentElement('afterend', colorError);
                    }
                }
                colorError.classList.remove('tw-hidden');
                hasErrors = true;
            } else {
                document.querySelector("#tertiary-color-error")?.classList.add('tw-hidden');
            }

            if (!selectedIcon && !hasCustomIcon) {
                let iconError = document.querySelector("#tertiary-icon-error");
                if (!iconError) {
                    iconError = document.createElement('small');
                    iconError.id = 'tertiary-icon-error';
                    iconError.className = 'tw-text-[#ff0000] tw-font-secondary';
                    iconError.textContent = 'Please select an icon or upload a custom icon';
                    const customLogoSection = document.querySelector('.tertiary__form .custom__logo');
                    if (customLogoSection) {
                        customLogoSection.insertAdjacentElement('afterend', iconError);
                    }
                }
                iconError.classList.remove('tw-hidden');
                hasErrors = true;
            } else {
                document.querySelector("#tertiary-icon-error")?.classList.add('tw-hidden');
            }

            if (hasErrors) {
                if (needsTop && (!topNameField || !topNameField.value.trim())) {
                    document.querySelector('#tertiary-top-name-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else if (needsBottom && (!bottomNameField || !bottomNameField.value.trim())) {
                    document.querySelector('#tertiary-bottom-name-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else if (!colorField) {
                    document.querySelector("#tertiary-color-error")?.scrollIntoView({ behavior: 'smooth', block: "center" });
                } else if (!selectedIcon && !hasCustomIcon) {
                    document.querySelector("#tertiary-icon-error")?.scrollIntoView({ behavior: 'smooth', block: "center" });
                }
            }

            return !hasErrors;
        }

        // ===== CAPS FLOW =====
        const nameField = document.querySelector('.tertiary__form #name');
        const errorEl = document.querySelector('#tertiary-error-message');

        if (!nameField || !nameField.value.trim()) {
            errorEl?.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            errorEl?.classList.add('tw-hidden');
        }

        if (!colorField) {
            let colorError = document.querySelector("#tertiary-color-error");
            if (!colorError) {
                colorError = document.createElement('small');
                colorError.id = 'tertiary-color-error';
                colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                colorError.textContent = 'Please select a font color';
                const tertiaryColorPicker = document.querySelector('.tertiary__form tertiary-color-picker');
                if (tertiaryColorPicker) {
                    tertiaryColorPicker.insertAdjacentElement('afterend', colorError);
                } else {
                    document.querySelector('.tertiary__form .radio__color').insertAdjacentElement('afterend', colorError);
                }
            }
            colorError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            document.querySelector("#tertiary-color-error")?.classList.add('tw-hidden');
        }

        if (!selectedIcon && !hasCustomIcon) {
            let iconError = document.querySelector("#tertiary-icon-error");
            if (!iconError) {
                iconError = document.createElement('small');
                iconError.id = 'tertiary-icon-error';
                iconError.className = 'tw-text-[#ff0000] tw-font-secondary';
                iconError.textContent = 'Please select an icon or upload a custom icon';
                const customLogoSection = document.querySelector('.tertiary__form .custom__logo');
                if (customLogoSection) {
                    customLogoSection.insertAdjacentElement('afterend', iconError);
                }
            }
            iconError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            document.querySelector("#tertiary-icon-error")?.classList.add('tw-hidden');
        }

        if (hasErrors) {
            if (!nameField || !nameField.value.trim()) {
                errorEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (!colorField) {
                document.querySelector("#tertiary-color-error")?.scrollIntoView({ behavior: 'smooth', block: "center" });
            } else if (!selectedIcon && !hasCustomIcon) {
                document.querySelector("#tertiary-icon-error")?.scrollIntoView({ behavior: 'smooth', block: "center" });
            }
        }

        return !hasErrors;
    }

    if (formType === 'Icon') {
        const selectedIcon = document.querySelector('.secondary__form input[name="icon"]:checked') ||
            document.querySelector('.icon-input:checked');
        const customIconInput = document.getElementById('property-custom-icon');
        const hasCustomIcon = customIconInput && customIconInput.files && customIconInput.files.length > 0;

        if (!selectedIcon && !hasCustomIcon) {
            let iconError = document.querySelector("#secondary-icon-error");
            if (!iconError) {
                iconError = document.createElement('small');
                iconError.id = 'secondary-icon-error';
                iconError.className = 'tw-text-[#ff0000] tw-font-secondary tw-block tw-mt-4';
                iconError.textContent = 'Please select an icon or upload a custom icon';
                const customLogoSection = document.querySelector('.secondary__form .custom__logo');
                if (customLogoSection) {
                    customLogoSection.insertAdjacentElement('afterend', iconError);
                } else {
                    const formWrapper = document.querySelector('.secondary__form');
                    if (formWrapper) {
                        formWrapper.appendChild(iconError);
                    }
                }
            }
            iconError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            document.querySelector("#secondary-icon-error")?.classList.add('tw-hidden');
        }

        if (hasErrors) {
            document.querySelector("#secondary-icon-error")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return !hasErrors;
    }

    return true;
}

class AddButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', () => {
            this.addToStorage();
        });
    }

    addToStorage() {
        if (!validateRequiredFields(this.dataset.form)) {
            return;
        }

        clearFormData(this.dataset.form);

        // ===== 'Name' handling =====
        if (this.dataset.form == 'Name') {
            const placementSelect = document.getElementById('text-placement-select');

            if (placementSelect) {
                // ===== EMBROIDERY FLOW =====
                const placementOption = placementSelect.value;
                const needsTop = placementOption !== 'bottom-only';
                const needsBottom = placementOption !== 'top-only';

                const primaryCombinedPlacementLabel = needsTop && needsBottom
                    ? 'Left Chest & Left Thigh'
                    : (needsTop ? 'Left Chest' : 'Left Thigh');

                const formData = {
                    placementOption: placementOption,
                    topName: needsTop ? (document.getElementById('top-name')?.value || '') : '',
                    topDesignation: needsTop ? (document.getElementById('top-designation')?.value || '') : '',
                    bottomName: needsBottom ? (document.getElementById('bottom-name')?.value || '') : '',
                    color: document.querySelector('.primary__form .radio__color input[name="color"]:checked').value,
                    font: document.querySelector('.primary__form .radio__fonts input[name="font"]:checked').value,
                    price: document.querySelector('#primary-form-price').textContent,
                    formName: this.dataset.form,
                    textplacementValue: primaryCombinedPlacementLabel,
                    specialRequest: document.querySelector('.primary__form #specialreq') ? document.querySelector('.primary__form #specialreq').value : '',
                    icon: '',
                    customIcon: '',
                    iconplacementValue: ''
                };

                setCookie('formData', formData);
                setCookie('color-name', document.querySelector('[data-color-value]:checked').dataset.colorValue);

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetSecondaryForm();
            } else {
                // ===== CAPS FLOW =====
                const isCapTemplate = document.body.classList.contains('template-personalised-cap') || document.body.classList.contains('template-personalised-cap-variant');

                const formData = {
                    textplacementValue: isCapTemplate ? '' : (document.getElementById('placementValue')?.textContent || ''),
                    name: document.getElementById('name').value,
                    designation: document.getElementById('designation').value,
                    color: document.querySelector('.primary__form .radio__color input[name="color"]:checked').value,
                    font: document.querySelector('.primary__form .radio__fonts input[name="font"]:checked').value,
                    price: document.querySelector('#primary-form-price').textContent,
                    formName: this.dataset.form,
                    specialRequest: document.querySelector('.primary__form #specialreq') ? document.querySelector('.primary__form #specialreq').value : '',
                    icon: '',
                    customIcon: '',
                    iconplacementValue: ''
                };

                setCookie('formData', formData);
                setCookie('color-name', document.querySelector('[data-color-value]:checked').dataset.colorValue);

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetSecondaryForm();
            }
        }

        // ===== 'Icon' handling =====
        // isCapTemplate check is orthogonal to embroidery/caps — it only controls whether
        // iconplacementValue text gets captured (some cap templates don't show it).
        if (this.dataset.form == 'Icon') {
            const fileInput = document.getElementById('property-custom-icon');
            const hasFile = fileInput.files.length > 0;
            const selectedIcon = document.querySelector('input[name="icon"]:checked');

            if (!hasFile && !selectedIcon) {
                let iconError = document.querySelector("#secondary-icon-error");
                if (iconError) {
                    iconError.classList.remove('tw-hidden');
                    iconError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            const isCapTemplate = document.body.classList.contains('template-personalised-cap') || document.body.classList.contains('template-personalised-cap-variant');

            if (hasFile) {
                const file = fileInput.value;
                const dataFile = fileInput.files[0];
                const reader = new FileReader();

                reader.onload = () => {
                    document.querySelectorAll('input[name="icon"]').forEach((input) => {
                        input.checked = false;
                    });

                    const customIconBase64 = reader.result;
                    const formData = {
                        price: document.querySelector('#secondary-custom-icon-price').value,
                        formName: this.dataset.form,
                        iconplacementValue: isCapTemplate ? '' : document.getElementById('secondary-placement').textContent,
                        icon: '',
                        customIcon: file,
                        previewCustomIcon: customIconBase64,
                        specialRequest: document.querySelector('.secondary__form #specialreq') ?
                            document.querySelector('.secondary__form #specialreq').value : '',
                        name: '',
                        designation: '',
                        textplacementValue: ''
                    };

                    // The base64 preview can push this past the browser's localStorage quota
                    // (large uploads especially) — if so, skip the local preview rather than
                    // letting the exception abort the rest of the add-to-cart flow below.
                    // submitFormToLineProperties() falls back to reading the live file input
                    // directly when previewCustomIcon isn't in storage.
                    try {
                        localStorage.setItem('formData', JSON.stringify(formData));
                    } catch (error) {
                        console.warn('Could not cache personalization preview locally (storage quota exceeded); continuing without it.', error);
                    }

                    setCookie('formData', {
                        price: formData.price,
                        formName: formData.formName,
                        iconplacementValue: formData.iconplacementValue,
                        customIcon: file,
                        specialRequest: formData.specialRequest,
                        name: '',
                        designation: '',
                        textplacementValue: ''
                    });

                    const colorValue = document.querySelector('[data-color-value]:checked');
                    if (colorValue) {
                        setCookie('color-name', colorValue.dataset.colorValue);
                    }

                    const formElement = document.querySelector('[data-product-form]');
                    submitFormToLineProperties(formElement);
                    bundlePersonalization(formElement);
                    checkLocalStorage();
                    document.querySelector('.close__icon').click();
                    resetPrimaryForm();
                };

                reader.readAsDataURL(dataFile);
            }
            else if (selectedIcon) {
                const formData = {
                    price: document.querySelector('#secondary-icon-price').value,
                    formName: this.dataset.form,
                    iconplacementValue: isCapTemplate ? '' : document.getElementById('secondary-placement').textContent,
                    icon: selectedIcon.dataset.img,
                    customIcon: '',
                    specialRequest: document.querySelector('.secondary__form #specialreq') ?
                        document.querySelector('.secondary__form #specialreq').value : '',
                    name: '',
                    designation: '',
                    textplacementValue: ''
                };

                setCookie('formData', formData);

                const colorValue = document.querySelector('[data-color-value]:checked');
                if (colorValue) {
                    setCookie('color-name', colorValue.dataset.colorValue);
                }

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetPrimaryForm();
            }
        }

        // NOTE: 'Name and Icon' add-to-cart flow is fully handled by TertiaryForm.addDataToStorage()
        // (attached to #tertiary-submit via connectedCallback). This AddButton class is not used
        // for the tertiary form's submit button, so no 'Name and Icon' branch is needed here.
    }
}

customElements.define('add-button', AddButton);


// clearFormData keeps whichever fields exist for the given formType — safe superset covering
// both embroidery (placementOption/topName/topDesignation/bottomName) and caps (name/designation/
// textplacementValue) shapes; unused keys are simply never populated by the `if` guards.
function clearFormData(formType) {
    const formData = getCookie('formData') ||
        (localStorage.getItem('formData') ?
            JSON.parse(localStorage.getItem('formData')) :
            null);

    if (!formData) return;

    let newFormData = {};

    if (formType === 'Name') {
        if (formData.placementOption) newFormData.placementOption = formData.placementOption;
        if (formData.topName) newFormData.topName = formData.topName;
        if (formData.topDesignation) newFormData.topDesignation = formData.topDesignation;
        if (formData.bottomName) newFormData.bottomName = formData.bottomName;
        if (formData.name) newFormData.name = formData.name;
        if (formData.designation) newFormData.designation = formData.designation;
        if (formData.color) newFormData.color = formData.color;
        if (formData.font) newFormData.font = formData.font;
        if (formData.textplacementValue) newFormData.textplacementValue = formData.textplacementValue;
        if (formData.specialRequest) newFormData.specialRequest = formData.specialRequest;
        newFormData.formName = 'Name';
        if (formData.price) newFormData.price = formData.price;

        newFormData.icon = '';
        newFormData.customIcon = '';
        newFormData.iconplacementValue = '';
    }
    else if (formType === 'Icon') {
        if (formData.icon) newFormData.icon = formData.icon;
        if (formData.customIcon) newFormData.customIcon = formData.customIcon;
        if (formData.iconplacementValue) newFormData.iconplacementValue = formData.iconplacementValue;
        if (formData.specialRequest) newFormData.specialRequest = formData.specialRequest;
        newFormData.formName = 'Icon';
        if (formData.price) newFormData.price = formData.price;

        newFormData.name = '';
        newFormData.designation = '';
        newFormData.textplacementValue = '';
    }
    else if (formType === 'Name and Icon') {
        newFormData = { ...formData };
        newFormData.formName = 'Name and Icon';
    }

    setCookie('formData', newFormData);
    localStorage.setItem('formData', JSON.stringify(newFormData));
}


class ResetButton extends HTMLElement {
    constructor() {
        super();
        this.buttonValue = this.dataset.button;
        this.addEventListener('click', () => {
            if (this.buttonValue == 'primary') {
                resetPrimaryForm();
            }
            if (this.buttonValue == 'secondary') {
                resetSecondaryForm();
            }
        });
    }
}
customElements.define('reset-button', ResetButton);

// resetPrimaryForm resets whichever field set is present — safe for both flows.
function resetPrimaryForm() {
    document.getElementById('primary-form').reset();

    const placementSelect = document.getElementById('text-placement-select');
    if (placementSelect) {
        placementSelect.value = 'top-bottom';
        placementSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const topNameField = document.getElementById('top-name');
    const topDesignationField = document.getElementById('top-designation');
    const bottomNameField = document.getElementById('bottom-name');
    if (topNameField) topNameField.value = '';
    if (topDesignationField) topDesignationField.value = '';
    if (bottomNameField) bottomNameField.value = '';

    const nameField = document.getElementById('name');
    const designationField = document.getElementById('designation');
    if (nameField) nameField.value = '';
    if (designationField) designationField.value = '';

    const colorRadios = document.querySelectorAll('.color-input');
    const fontRadios = document.querySelectorAll('.font-input');
    const colorLabels = document.querySelectorAll('.color-label');
    const fontLabels = document.querySelectorAll('.font-label');

    const specialReqTextarea = document.querySelector('.primary__form #specialreq');
    if (specialReqTextarea) {
        specialReqTextarea.value = '';
    }

    colorRadios.forEach(radio => radio.checked = false);
    fontRadios.forEach(radio => radio.checked = false);

    document.getElementById('font#1').checked = true;

    colorLabels.forEach(label => {
        label.style.border = 0;
        label.style.padding = 0;
        label.style.width = '3.2rem';
        label.style.height = '1.6rem';
        label.style.outline = 'none';
    });

    fontLabels.forEach(label => {
        label.style.border = 'none';
    });

    document.querySelector("#top-name-error")?.classList.add("tw-hidden");
    document.querySelector("#bottom-name-error")?.classList.add("tw-hidden");
    document.querySelector("#primary-error-message")?.classList.add("tw-hidden");
    document.querySelector("#primary-color-error")?.classList.add("tw-hidden");

    const selectedColorSpan = document.getElementById('selected-color');
    if (selectedColorSpan) {
        selectedColorSpan.textContent = '';
    }

    initialRadioCheckForFont(document, document.getElementById('selected-font'));
}

function resetSecondaryForm() {
    document.querySelector('.secondary__form').reset();

    const specialReqTextarea = document.querySelector('.secondary__form #specialreq');
    if (specialReqTextarea) {
        specialReqTextarea.value = '';
    }

    const radioIcons = document.querySelectorAll('.icon-input');
    const iconLabels = document.querySelectorAll('.icon-label');
    const uploadLabel = document.getElementById('upload-label');
    const fileDisclaimer = document.getElementById('file-disclaimer');
    const labelAbbr = document.getElementById('label-abbr');
    uploadLabel.textContent = uploadLabel.dataset.labelValue;
    if (document.querySelector('[name="properties[Icon]"]')) {
        document.querySelector('[name="properties[Icon]"]').value = '';
    }
    if (document.querySelector('[name="properties[IconPlacement]"]')) {
        document.querySelector('[name="properties[IconPlacement]"]').value = '';
    }
    document.getElementById('property-custom-icon').value = '';
    fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
    fileDisclaimer.style.fontWeight = 'normal';
    labelAbbr.title = '';

    radioIcons.forEach(radio => radio.checked = false);

    document.getElementById('icon-1').checked = true;

    iconLabels.forEach(label => {
        label.style.border = '0';
        label.style.padding = 0;
        label.style.width = '3.6rem';
        label.style.height = '3.6rem';
    })

    initialRadioCheckForIcon(document, document.getElementById('selected-icon'));
}


class TertiaryForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const resetButton = document.getElementById('tertiary-reset');
        if (resetButton) {
            resetButton.addEventListener('click', () => this.resetTertiaryForm());
        }

        const addButton = document.getElementById('tertiary-submit');
        if (addButton) {
            addButton.addEventListener('click', () => this.addDataToStorage());
        }
    }

    addDataToStorage() {
        if (!validateRequiredFields('Name and Icon')) {
            return;
        }

        clearFormData('Name and Icon');

        const placementSelect = this.querySelector('#tertiary-text-placement-select') || document.getElementById('tertiary-text-placement-select');
        const fileInput = document.querySelector('#property-custom-icon');
        const file = fileInput.value;
        const dataFile = fileInput.files[0];
        const reader = new FileReader();

        if (placementSelect) {
            // ===== EMBROIDERY FLOW =====
            const placementOption = placementSelect.value;
            const needsTop = placementOption !== 'bottom-only';
            const needsBottom = placementOption !== 'top-only';
            const isTopBottom = placementOption === 'top-bottom';

            const tertiaryCombinedPlacementLabel = needsTop && needsBottom
                ? 'Left Chest & Left Thigh'
                : (needsTop ? 'Left Chest' : 'Left Thigh');

            const buildBaseData = (price) => ({
                placementOption: placementOption,
                topName: needsTop ? (this.querySelector('#tertiary-top-name')?.value || '') : '',
                topDesignation: needsTop ? (this.querySelector('#tertiary-top-designation')?.value || '') : '',
                bottomName: needsBottom ? (this.querySelector('#tertiary-bottom-name')?.value || '') : '',
                color: this.querySelector('input[name="color"]:checked').value,
                font: this.querySelector('input[name="font"]:checked').value,
                price: price,
                formName: 'Name and Icon',
                textplacementValue: tertiaryCombinedPlacementLabel,
                iconplacementValue: this.querySelector('#icon-placement')?.textContent || '',
                specialRequest: this.querySelector('#specialreq') ? this.querySelector('#specialreq').value : ''
            });
            const hasValidName = (data) => (needsTop && data.topName) || (needsBottom && data.bottomName);

            reader.onload = () => {
                this.querySelectorAll('input[name="icon"]').forEach((input) => {
                    input.removeAttribute('checked');
                });

                const customIconBase64 = reader.result;
                const price = isTopBottom
                    ? document.getElementById('tertiary-custom-icon-price-top-bottom').value
                    : document.getElementById('tertiary-custom-icon-price').value;

                const formData = {
                    ...buildBaseData(price),
                    icon: '',
                    customIcon: file,
                    previewCustomIcon: customIconBase64
                };

                if (hasValidName(formData)) {
                    // Full data (with base64 preview) stays in localStorage.
                    // Cookie holds only the lightweight subset (no base64) — cookies overflow ~4KB.
                    // A large upload can also exceed localStorage's own quota — catch that so the
                    // rest of the add-to-cart flow below still runs (submitFormToLineProperties
                    // falls back to the live file input when previewCustomIcon isn't stored).
                    try {
                        localStorage.setItem('formData', JSON.stringify(formData));
                    } catch (error) {
                        console.warn('Could not cache personalization preview locally (storage quota exceeded); continuing without it.', error);
                    }

                    setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                    setCookie('formData', {
                        placementOption: formData.placementOption,
                        topName: formData.topName,
                        topDesignation: formData.topDesignation,
                        bottomName: formData.bottomName,
                        color: formData.color,
                        font: formData.font,
                        price: formData.price,
                        formName: formData.formName,
                        textplacementValue: formData.textplacementValue,
                        iconplacementValue: formData.iconplacementValue,
                        icon: formData.icon,
                        customIcon: file,
                        specialRequest: formData.specialRequest
                    });

                    const formElement = document.querySelector('[data-product-form]');
                    submitFormToLineProperties(formElement);
                    bundlePersonalization(formElement);
                    checkLocalStorage();
                    document.querySelector('.close__icon').click();
                } else {
                    document.querySelector('#tertiary-top-name-error')?.classList.remove('tw-hidden');
                    document.querySelector('#tertiary-top-name-error')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            };

            if (dataFile) {
                reader.readAsDataURL(dataFile);
            } else {
                const selectedIcon = this.querySelector('input[name="icon"]:checked');
                const price = isTopBottom
                    ? document.getElementById('tertiary-icon-price-top-bottom').value
                    : document.getElementById('tertiary-icon-price').value;

                const formData = {
                    ...buildBaseData(price),
                    icon: selectedIcon ? selectedIcon.dataset.img : '',
                    customIcon: ''
                };

                if (hasValidName(formData)) {
                    setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                    setCookie('formData', formData);

                    const formElement = document.querySelector('[data-product-form]');
                    submitFormToLineProperties(formElement);
                    bundlePersonalization(formElement);
                    checkLocalStorage();
                    document.querySelector('.close__icon').click();
                    resetPrimaryForm();
                    resetSecondaryForm();
                } else {
                    document.querySelector('#tertiary-top-name-error')?.classList.remove('tw-hidden');
                    document.querySelector('#tertiary-top-name-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
            return;
        }

        // ===== CAPS FLOW =====
        const isCapTemplate = document.body.classList.contains('template-personalised-cap') || document.body.classList.contains('template-personalised-cap-variant');

        reader.onload = () => {
            this.querySelectorAll('input[name="icon"]').forEach((input) => {
                input.removeAttribute('checked');
            });

            const customIconBase64 = reader.result;

            const formData = {
                name: this.querySelector('#name').value,
                designation: this.querySelector('#designation').value,
                color: this.querySelector('input[name="color"]:checked').value,
                font: this.querySelector('input[name="font"]:checked').value,
                price: document.querySelector('#tertiary-custom-icon-price').value,
                formName: 'Name and Icon',
                textplacementValue: isCapTemplate ? '' : this.querySelector('#text-placement')?.textContent,
                iconplacementValue: isCapTemplate ? '' : this.querySelector('#icon-placement')?.textContent,
                icon: this.querySelector('input[name="icon"]:checked') ? this.querySelector('input[name="icon"]:checked').dataset.img : '',
                customIcon: file,
                previewCustomIcon: customIconBase64,
                specialRequest: this.querySelector('#specialreq') ? this.querySelector('#specialreq').value : ''
            };

            if (formData.name) {
                // See the embroidery-flow branch above: a large upload can exceed
                // localStorage's quota — catch it so the rest of the flow still runs.
                try {
                    localStorage.setItem('formData', JSON.stringify(formData));
                } catch (error) {
                    console.warn('Could not cache personalization preview locally (storage quota exceeded); continuing without it.', error);
                }
                setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                setCookie('formData', {
                    name: formData.name,
                    designation: formData.designation,
                    color: formData.color,
                    font: formData.font,
                    price: formData.price,
                    formName: formData.formName,
                    textplacementValue: formData.textplacementValue,
                    iconplacementValue: formData.iconplacementValue,
                    icon: formData.icon,
                    customIcon: file,
                    specialRequest: formData.specialRequest
                });

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
            } else {
                document.querySelector('#tertiary-error-message')?.classList.remove('tw-hidden');
                document.querySelector('#tertiary-error-message')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        if (dataFile) {
            reader.readAsDataURL(dataFile);
        }
        else {
            const formData = {
                name: this.querySelector('#name').value,
                designation: this.querySelector('#designation').value,
                color: this.querySelector('input[name="color"]:checked').value,
                font: this.querySelector('input[name="font"]:checked').value,
                price: document.querySelector('#tertiary-icon-price').value,
                formName: 'Name and Icon',
                textplacementValue: isCapTemplate ? '' : this.querySelector('#text-placement')?.textContent,
                iconplacementValue: isCapTemplate ? '' : this.querySelector('#icon-placement')?.textContent,
                icon: this.querySelector('input[name="icon"]:checked') ? this.querySelector('input[name="icon"]:checked').dataset.img : '',
                customIcon: '',
                specialRequest: this.querySelector('#specialreq') ? this.querySelector('#specialreq').value : ''
            };

            if (formData.name) {
                setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                setCookie('formData', {
                    name: formData.name,
                    designation: formData.designation,
                    color: formData.color,
                    font: formData.font,
                    price: formData.price,
                    formName: formData.formName,
                    textplacementValue: formData.textplacementValue,
                    iconplacementValue: formData.iconplacementValue,
                    icon: formData.icon,
                    customIcon: formData.customIcon,
                    specialRequest: formData.specialRequest
                });

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetPrimaryForm();
                resetSecondaryForm();
            } else {
                document.querySelector('#tertiary-error-message')?.classList.remove('tw-hidden');
                document.querySelector('#tertiary-error-message')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    resetTertiaryForm() {
        document.querySelector('.tertiary__form').reset();

        const specialReqTextarea = this.querySelector('#specialreq');
        if (specialReqTextarea) {
            specialReqTextarea.value = '';
        }

        const colorRadios = this.querySelectorAll('.tertiary-color-input');
        const fontRadios = this.querySelectorAll('.tertiary-font-input');
        const colorLabels = this.querySelectorAll('.tertiary-color-label');
        const fontLabels = this.querySelectorAll('.tertiary-font-label');

        colorRadios.forEach(radio => radio.checked = false);
        fontRadios.forEach(radio => radio.checked = false);

        this.querySelector('#tertiary-font-1').checked = true;

        colorLabels.forEach(label => {
            label.style.border = '0';
            label.style.padding = 0;
            label.style.width = '3.2rem';
            label.style.height = '1.6rem';
            label.style.outline = 'none';
        });

        fontLabels.forEach(label => {
            label.style.border = '0.1rem solid #808080';
        });

        const selectedColorSpan = this.querySelector('#selected-color');
        if (selectedColorSpan) {
            selectedColorSpan.textContent = '';
        }

        initialRadioCheckForFont(this, this.querySelector('#selected-font'));

        const radioIcons = this.querySelectorAll('.tertiary-icon-input');
        const iconLabels = this.querySelectorAll('.tertiary-icon-label');
        const uploadLabelTertiary = this.querySelector('#upload-label');
        const fileDisclaimerTertiary = this.querySelector('#file-disclaimer');
        const labelAbbrTertiary = this.querySelector('#label-abbr');
        uploadLabelTertiary.textContent = uploadLabelTertiary.dataset.labelValue;
        document.getElementById('property-custom-icon').value = '';
        fileDisclaimerTertiary.textContent = 'Only Accepting files lesser than 10MB';
        fileDisclaimerTertiary.style.fontWeight = 'normal';
        labelAbbrTertiary.title = '';

        radioIcons.forEach(radio => radio.checked = false);

        document.getElementById('tertiary-icon-1').checked = true;

        iconLabels.forEach(label => {
            label.style.border = '0';
            label.style.padding = 0;
            label.style.width = '3.6rem';
            label.style.height = '3.6rem';
        });

        // Reset placement dropdown (embroidery flow only — no-op if absent)
        const tertiaryPlacementSelect = this.querySelector('#tertiary-text-placement-select') || document.getElementById('tertiary-text-placement-select');
        if (tertiaryPlacementSelect) {
            tertiaryPlacementSelect.value = 'top-bottom';
            tertiaryPlacementSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const tertiaryTopNameField = this.querySelector('#tertiary-top-name');
        const tertiaryTopDesignationField = this.querySelector('#tertiary-top-designation');
        const tertiaryBottomNameField = this.querySelector('#tertiary-bottom-name');
        if (tertiaryTopNameField) tertiaryTopNameField.value = '';
        if (tertiaryTopDesignationField) tertiaryTopDesignationField.value = '';
        if (tertiaryBottomNameField) tertiaryBottomNameField.value = '';

        // Caps flow fields
        const tertiaryNameField = this.querySelector('#name');
        const tertiaryDesignationField = this.querySelector('#designation');
        if (tertiaryNameField) tertiaryNameField.value = '';
        if (tertiaryDesignationField) tertiaryDesignationField.value = '';

        document.querySelector('#tertiary-top-name-error')?.classList.add('tw-hidden');
        document.querySelector('#tertiary-bottom-name-error')?.classList.add('tw-hidden');
        document.querySelector('#tertiary-error-message')?.classList.add('tw-hidden');
        document.querySelector("#tertiary-color-error")?.classList.add('tw-hidden');
        document.querySelector("#tertiary-icon-error")?.classList.add('tw-hidden');

        initialRadioCheckForIcon(this, this.querySelector('#selected-icon'));

        clearFormData('Name and Icon');
    }
}

customElements.define('tertiary-form', TertiaryForm);

// checkLocalStorage: 'Name' and 'Name and Icon' branches key off savedFormData.placementOption
// (only ever set by the embroidery/top-bottom flow) to decide which preview logic to run.
//
// IMPORTANT: Top AND bottom text elements are ALWAYS written (even if empty / hidden) BEFORE
// toggling `tw-hidden` on `.preview-top-block` / `.preview-bottom-block`. This prevents stale
// values from lingering when the user switches placement options or resets the form.
//
// Also: cookie data is MERGED with localStorage data. The cookie never contains previewCustomIcon
// (base64 image data would exceed the ~4KB cookie limit and silently fail), so we fall back to
// localStorage whenever the cookie is missing or partial.
function checkLocalStorage() {
    const cookieFormData = getCookie('formData');
    const savedColorName = getCookie('color-name');

    const localStorageFormData = localStorage.getItem('formData')
        ? JSON.parse(localStorage.getItem('formData'))
        : null;

    // Merge: cookie values win, localStorage fills in missing keys (e.g. previewCustomIcon).
    const savedFormData = (cookieFormData || localStorageFormData)
        ? { ...(localStorageFormData || {}), ...(cookieFormData || {}) }
        : null;

    if (savedFormData) {
        document.querySelector('.fit--dis__text').style.display = 'none';
        document.getElementById('personalization-btn').style.display = 'none';
        const personalizeDetails = document.getElementById('personalize-details');
        personalizeDetails.classList.remove('tw-hidden');
        personalizeDetails.classList.add('tw-flex');

        // ===== Handle Name personalization =====
        if (savedFormData.formName == 'Name') {
            document.querySelector('.primary_form_preview').classList.remove('tw-hidden');
            document.querySelector('.primary_form_preview').classList.add('tw-flex');

            document.querySelector('.secondary_form_preview').classList.remove('tw-flex');
            document.querySelector('.secondary_form_preview').classList.add('tw-hidden');

            document.querySelector('.tertiary_form_preview').classList.remove('tw-flex');
            document.querySelector('.tertiary_form_preview').classList.add('tw-hidden');

            const color = savedFormData.color;
            const font = savedFormData.font;
            const price = savedFormData.price;

            document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
                if (element.checked) {
                    document.getElementById('preview-primary-background').style.backgroundColor = element.dataset.bgColorPreview;
                    const bottomBg = document.getElementById('preview-bottom-background');
                    if (bottomBg) bottomBg.style.backgroundColor = element.dataset.bgColorPreview;
                }
            });

            const matchingColorInput = document.querySelector(`input[name="color"][value="${savedFormData.color}"]`);
            const colorValue = matchingColorInput ? matchingColorInput.dataset.colorValue : null;

            if (savedFormData.placementOption) {
                // ===== EMBROIDERY: top/bottom preview =====
                const placementOption = savedFormData.placementOption;
                const showTop = placementOption !== 'bottom-only';
                const showBottom = placementOption !== 'top-only';

                // --- ALWAYS update TOP text elements (regardless of visibility) ---
                const topName = savedFormData.topName || '';
                const topDesignation = savedFormData.topDesignation || '';

                const userNameEl = document.getElementById('user-name');
                if (userNameEl) {
                    userNameEl.textContent = topName;
                    if (colorValue) userNameEl.style.color = colorValue;
                    userNameEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                }

                const previewNameEl = document.getElementById('preview-name');
                if (previewNameEl) previewNameEl.textContent = topName;

                const previewDesigEl = document.getElementById('preview-designation');
                const previewDesigUserEl = document.getElementById('preview-designation-user');
                if (topDesignation) {
                    if (previewDesigUserEl) {
                        previewDesigUserEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                        if (colorValue) previewDesigUserEl.style.color = colorValue;
                        previewDesigUserEl.textContent = topDesignation;
                    }
                    if (previewDesigEl) previewDesigEl.textContent = ", " + topDesignation;
                } else {
                    if (previewDesigEl) previewDesigEl.textContent = "";
                    if (previewDesigUserEl) previewDesigUserEl.textContent = "";
                }

                // --- ALWAYS update BOTTOM text elements (regardless of visibility) ---
                const bottomName = savedFormData.bottomName || '';

                const bottomNameEl = document.getElementById('preview-bottom-name');
                if (bottomNameEl) bottomNameEl.textContent = bottomName;

                const bottomUserNameEl = document.getElementById('bottom-user-name');
                if (bottomUserNameEl) {
                    bottomUserNameEl.textContent = bottomName;
                    if (colorValue) bottomUserNameEl.style.color = colorValue;
                    bottomUserNameEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                }

                const bottomTextColorEl = document.getElementById('bottom-text-color');
                if (bottomTextColorEl) bottomTextColorEl.textContent = color;
                const bottomPreviewFontEl = document.getElementById('bottom-preview-font');
                if (bottomPreviewFontEl) bottomPreviewFontEl.textContent = font;

                const bottomPlacementEl = document.getElementById('bottom-text-placement');
                if (bottomPlacementEl) bottomPlacementEl.textContent = 'Left Thigh';

                // --- Toggle visibility AFTER content is updated ---
                const topBlock = document.querySelector('.primary_form_preview .preview-top-block');
                if (topBlock) topBlock.classList.toggle('tw-hidden', !showTop);

                const bottomBlock = document.querySelector('.primary_form_preview .preview-bottom-block');
                if (bottomBlock) bottomBlock.classList.toggle('tw-hidden', !showBottom);

                // --- Top card's own placement text ---
                // This element lives inside the TOP card specifically — it should only ever
                // describe the top placement ("Left Chest"). The bottom card already shows its
                // own "Left Thigh" independently via bottomPlacementEl above, so combining both
                // into this single Top-card line was showing "Left Chest & Left Thigh" on a card
                // explicitly labeled "(Top)", which read as if Top itself was placed at the thigh.
                const textPlacementEl = document.getElementById('text-placement');
                if (textPlacementEl) {
                    textPlacementEl.textContent = 'Left Chest';
                }
            } else {
                // ===== CAPS: flat name/designation preview =====
                // (bottom block, if present in markup, stays whatever state it defaults to —
                // caps products never populate it.)
                const name = savedFormData.name || '';
                const designation = savedFormData.designation || '';
                const placementValue = savedFormData.textplacementValue;

                const userNameEl = document.getElementById('user-name');
                if (userNameEl) {
                    userNameEl.textContent = name;
                    if (colorValue) userNameEl.style.color = colorValue;
                    userNameEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                }

                const previewNameEl = document.getElementById('preview-name');
                if (previewNameEl) previewNameEl.textContent = name;

                const previewDesigEl = document.getElementById('preview-designation');
                const previewDesigUserEl = document.getElementById('preview-designation-user');
                if (designation) {
                    if (previewDesigUserEl) {
                        previewDesigUserEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                        if (colorValue) previewDesigUserEl.style.color = colorValue;
                        previewDesigUserEl.textContent = designation;
                    }
                    if (previewDesigEl) previewDesigEl.textContent = ", " + designation;
                } else {
                    if (previewDesigEl) previewDesigEl.textContent = "";
                    if (previewDesigUserEl) previewDesigUserEl.textContent = "";
                }

                const textPlacementEl = document.getElementById('text-placement');
                if (textPlacementEl) textPlacementEl.textContent = placementValue;
            }

            const textColorEl = document.getElementById('text-color');
            if (textColorEl) textColorEl.textContent = color;
            const previewFontEl = document.getElementById('preview-font');
            if (previewFontEl) previewFontEl.textContent = font;
            const priceValueEl = document.getElementById('price-value');
            if (priceValueEl) priceValueEl.textContent = price;
        }

        // ===== Handle Icon personalization =====
        else if (savedFormData.formName == 'Icon') {
            document.querySelector('.secondary_form_preview').classList.remove('tw-hidden');
            document.querySelector('.secondary_form_preview').classList.add('tw-flex');

            document.querySelector('.primary_form_preview').classList.remove('tw-flex');
            document.querySelector('.primary_form_preview').classList.add('tw-hidden');

            document.querySelector('.tertiary_form_preview').classList.remove('tw-flex');
            document.querySelector('.tertiary_form_preview').classList.add('tw-hidden');

            document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
                if (element.checked) {
                    document.getElementById('icon-holder').style.backgroundColor = element.dataset.bgColorPreview;
                }
            })

            const placementValue = savedFormData.iconplacementValue;
            let icon = savedFormData.icon;

            const customIcon = localStorageFormData
                ? localStorageFormData.previewCustomIcon
                : (savedFormData.previewCustomIcon || null);

            const price = savedFormData.price;

            document.getElementById('price-value').textContent = price;

            if (customIcon) {
                document.getElementById('preview-icon').src = customIcon;
                document.getElementById('icon-value').textContent = placementValue;
                document.getElementById('icon-type').textContent = 'Custom';
            }
            else if (icon) {
                const cdnURL = 'https://cdn.shopify.com/s/files/1/0869/7551/2851/'
                document.getElementById('preview-icon').src = `${cdnURL}${icon}`;
                document.getElementById('icon-value').textContent = placementValue;

                icon = icon.replace("files/", "")
                    .replace(".png", "")
                    .replace(".svg", "")
                    .replace(".jpg", "")
                    .replace(".jpeg", "");

                document.getElementById('icon-type').textContent = icon;
            }
            if (savedFormData.specialRequest && savedFormData.specialRequest.trim() !== '') {
                const specialRequestPreview = document.getElementById('secondary-special-request-preview');
                const specialRequestText = document.getElementById('secondary-special-request-text');
                if (specialRequestPreview && specialRequestText) {
                    specialRequestPreview.classList.remove('tw-hidden');
                    specialRequestText.textContent = savedFormData.specialRequest;
                }
            } else {
                const specialRequestPreview = document.getElementById('secondary-special-request-preview');
                if (specialRequestPreview) {
                    specialRequestPreview.classList.add('tw-hidden');
                }
            }
        }

        // ===== Handle Name and Icon personalization =====
        else if (savedFormData.formName == 'Name and Icon') {
            document.querySelector('.tertiary_form_preview').classList.remove('tw-hidden');
            document.querySelector('.tertiary_form_preview').classList.add('tw-flex');

            document.querySelector('.primary_form_preview').classList.remove('tw-flex');
            document.querySelector('.primary_form_preview').classList.add('tw-hidden');

            document.querySelector('.secondary_form_preview').classList.remove('tw-flex');
            document.querySelector('.secondary_form_preview').classList.add('tw-hidden');

            let icon = savedFormData.icon;
            const customIcon = localStorageFormData ? localStorageFormData.previewCustomIcon : null;
            const iconplacementValue = savedFormData.iconplacementValue;
            const color = savedFormData.color;
            const font = savedFormData.font;
            const price = savedFormData.price;

            document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
                if (element.checked) {
                    const topBg = document.querySelector('.tertiary_form_preview #preview-primary-background');
                    const bottomBg = document.querySelector('.tertiary_form_preview #preview-bottom-background');
                    const iconBg = document.querySelector('.tertiary_form_preview #icon-holder');
                    if (topBg) topBg.style.backgroundColor = element.dataset.bgColorPreview;
                    if (bottomBg) bottomBg.style.backgroundColor = element.dataset.bgColorPreview;
                    if (iconBg) iconBg.style.backgroundColor = element.dataset.bgColorPreview;
                }
            });

            const matchingColorInput = document.querySelector(`input[name="color"][value="${savedFormData.color}"]`);
            if (matchingColorInput && matchingColorInput.dataset.colorValue) {
                document.getElementById('tertiary-user-name').style.color = matchingColorInput.dataset.colorValue;
                document.getElementById('tertiary-preview-designation-user').style.color = matchingColorInput.dataset.colorValue;
                const bottomUserNameEl = document.getElementById('tertiary-bottom-user-name');
                if (bottomUserNameEl) bottomUserNameEl.style.color = matchingColorInput.dataset.colorValue;
            }

            document.getElementById('tertiary-user-name').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';

            document.getElementById('price-value').textContent = price;

            if (savedFormData.placementOption) {
                // ===== EMBROIDERY: top/bottom preview =====
                const placementOption = savedFormData.placementOption;
                const showTop = placementOption !== 'bottom-only';
                const showBottom = placementOption !== 'top-only';

                // --- ALWAYS update TOP text elements (regardless of visibility) ---
                const topName = savedFormData.topName || '';
                const topDesignation = savedFormData.topDesignation || '';

                const topUserNameEl = document.getElementById('tertiary-user-name');
                if (topUserNameEl) {
                    topUserNameEl.textContent = topName;
                    topUserNameEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                }

                const topPreviewNameEl = document.getElementById('tertiary-preview-name');
                if (topPreviewNameEl) topPreviewNameEl.textContent = topName;

                const topDesigUserEl = document.getElementById('tertiary-preview-designation-user');
                const topDesigEl = document.getElementById('tertiary-preview-designation');
                if (topDesignation) {
                    if (topDesigUserEl) {
                        topDesigUserEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                        topDesigUserEl.textContent = topDesignation;
                    }
                    if (topDesigEl) topDesigEl.textContent = ", " + topDesignation;
                } else {
                    if (topDesigUserEl) topDesigUserEl.textContent = '';
                    if (topDesigEl) topDesigEl.textContent = '';
                }

                // --- ALWAYS update BOTTOM text elements (regardless of visibility) ---
                const bottomName = savedFormData.bottomName || '';

                const bottomPreviewNameEl = document.getElementById('tertiary-preview-bottom-name');
                if (bottomPreviewNameEl) bottomPreviewNameEl.textContent = bottomName;

                const bottomUserNameEl = document.getElementById('tertiary-bottom-user-name');
                if (bottomUserNameEl) {
                    bottomUserNameEl.textContent = bottomName;
                    bottomUserNameEl.style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                }

                const bottomPlacementEl = document.getElementById('tertiary-bottom-text-placement');
                if (bottomPlacementEl) bottomPlacementEl.textContent = 'Left Thigh';

                // --- Toggle visibility AFTER content is updated ---
                const topBlock = document.querySelector('.tertiary_form_preview .preview-top-block');
                if (topBlock) topBlock.classList.toggle('tw-hidden', !showTop);

                const bottomBlock = document.querySelector('.tertiary_form_preview .preview-bottom-block');
                if (bottomBlock) bottomBlock.classList.toggle('tw-hidden', !showBottom);

                // --- Shared color / font / placement text ---
                const tertiaryTextColorEl = document.getElementById('tertiary-text-color');
                if (tertiaryTextColorEl) tertiaryTextColorEl.textContent = color;

                const tertiaryPreviewFontEl = document.getElementById('tertiary-preview-font');
                if (tertiaryPreviewFontEl) tertiaryPreviewFontEl.textContent = font;

                // This element lives inside the TOP card specifically (see the matching 'Name'
                // branch above for why it should never show the combined "& Left Thigh" text).
                const tertiaryPlacementEl = document.getElementById('tertiary-text-placement');
                if (tertiaryPlacementEl) {
                    tertiaryPlacementEl.textContent = 'Left Chest';
                }
            } else {
                // ===== CAPS: flat name/designation preview =====
                const name = savedFormData.name || '';
                const designation = savedFormData.designation || '';
                const textplacementValue = savedFormData.textplacementValue;

                // Bottom block, if present in markup, is left untouched/hidden for caps products.
                const bottomBlock = document.querySelector('.tertiary_form_preview .preview-bottom-block');
                if (bottomBlock) bottomBlock.classList.add('tw-hidden');

                document.getElementById('tertiary-user-name').textContent = name;
                document.getElementById('tertiary-preview-name').textContent = name;

                if (designation) {
                    document.getElementById('tertiary-preview-designation-user').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
                    document.getElementById('tertiary-preview-designation').textContent = ", " + designation;
                    document.getElementById('tertiary-preview-designation-user').textContent = designation;
                } else {
                    document.getElementById('tertiary-preview-designation').textContent = '';
                    document.getElementById('tertiary-preview-designation-user').textContent = '';
                }

                document.getElementById('tertiary-text-color').textContent = color;
                document.getElementById('tertiary-preview-font').textContent = font;
                document.getElementById('tertiary-text-placement').textContent = textplacementValue;
            }

            if (customIcon) {
                document.getElementById('tertiary-preview-icon').src = customIcon;
                document.getElementById('tertiary-icon-value').textContent = iconplacementValue;
                document.getElementById('tertiary-icon-type').textContent = 'Custom';
            }
            else if (icon) {
                const cdnURL = 'https://cdn.shopify.com/s/files/1/0869/7551/2851/'
                document.getElementById('tertiary-preview-icon').src = `${cdnURL}${icon}`;
                document.getElementById('tertiary-icon-value').textContent = iconplacementValue;
                icon = icon.replace("files/", "").replace(".png", "").replace(".svg", "").replace(".jpg", "").replace(".jpeg", "");
                document.getElementById('tertiary-icon-type').textContent = icon;
            }

            if (savedFormData.specialRequest && savedFormData.specialRequest.trim() !== '') {
                const specialRequestPreview = document.getElementById('tertiary-special-request-preview');
                const specialRequestText = document.getElementById('tertiary-special-request-text');
                if (specialRequestPreview && specialRequestText) {
                    specialRequestPreview.classList.remove('tw-hidden');
                    specialRequestText.textContent = savedFormData.specialRequest;
                }
            } else {
                const specialRequestPreview = document.getElementById('tertiary-special-request-preview');
                if (specialRequestPreview) {
                    specialRequestPreview.classList.add('tw-hidden');
                }
            }
        }
    }
    else {
        if (document.querySelector('.fit--dis__text')) {
            document.querySelector('.fit--dis__text').style.display = 'flex';
        }
        if (document.getElementById('personalization-btn')) {
            document.getElementById('personalization-btn').style.display = 'flex';
        }
        const personalizeDetails = document.getElementById('personalize-details');
        if (personalizeDetails) {
            personalizeDetails.classList.remove('tw-flex');
            personalizeDetails.classList.add('tw-hidden');
        }
    }
}

function initialRadioCheckForColor(selector, selectedItem) {
    let checkedInput;
    if (!selector.querySelector(".color-input")) {
        checkedInput = selector.querySelector(".tertiary-color-input:checked");
    }
    else {
        checkedInput = selector.querySelector(".color-input:checked");
    }

    if (checkedInput) {
        selectedItem.textContent = checkedInput.value;

        const selectedLabel = checkedInput.previousElementSibling;
        if (selectedLabel) {
            selectedLabel.style.border = "0.1rem solid #f8f6f3";
            selectedLabel.style.width = '3.2rem';
            selectedLabel.style.height = '1.6rem';
            selectedLabel.style.outline = 'solid';
            selectedLabel.style.outlineWidth = '0.2rem';
            selectedLabel.style.outlineColor = '#808080';
        }
    } else {
        selectedItem.textContent = '';
    }
}

function initialRadioCheckForIcon(selector, selectedItem) {
    let initialSelectedInput;
    if (!selector.querySelector(".icon-input:checked")) {
        initialSelectedInput = selector.querySelector(".tertiary-icon-input:checked");
    }
    else {
        initialSelectedInput = selector.querySelector(".icon-input:checked");
    }
    if (initialSelectedInput) {
        selectedItem.textContent = initialSelectedInput.value;

        const initialSelectedLabel = initialSelectedInput.closest('label');
        if (initialSelectedLabel) {
            initialSelectedLabel.style.border = "0.1rem solid #292C35";
            initialSelectedLabel.style.padding = "0.2rem";
            initialSelectedLabel.style.width = '4rem';
            initialSelectedLabel.style.height = '4rem';
        }
    }
    else {
        const iconLabels = selector.querySelectorAll('.icon-label');
        iconLabels.forEach(label => {
            label.style.border = '0';
            label.style.padding = 0;
            label.style.width = '3.6rem';
            label.style.height = '3.6rem';
        });
    }
}

function initialRadioCheckForFont(selector, selectedItem) {
    let initialSelectedInput;
    if (!selector.querySelector(".font-input:checked")) {
        initialSelectedInput = selector.querySelector(".tertiary-font-input:checked")
    }
    else {
        initialSelectedInput = selector.querySelector(".font-input:checked");
    }
    if (initialSelectedInput) {
        selectedItem.textContent = initialSelectedInput.value;
        const initialSelectedLabel = initialSelectedInput.previousElementSibling;
        if (initialSelectedLabel) {
            initialSelectedLabel.style.border = "0.2rem solid #292c35";
        }
    }
}

class DeleteIcon extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.deleteData.bind(this));
    }

    deleteData() {
        removeCookie('formData');
        removeCookie('color-name');
        localStorage.removeItem('formData');

        checkLocalStorage();
        removeAllInputs();
        resetPrimaryForm();
        resetSecondaryForm();
    }
}
customElements.define('delete-icon', DeleteIcon);


document.addEventListener('DOMContentLoaded', () => {
    checkLocalStorage();
    const formElement = document.querySelector('[data-product-form]');
    submitFormToLineProperties(formElement);
    if (localStorage.getItem('bundleBody')) {
        bundlePersonalization(formElement);
    }
});

// submitFormToLineProperties: 'placementOption' in formData distinguishes embroidery (top/bottom)
// from caps (flat name/designation) saved data, writing to whichever hidden inputs exist.
//
// Cookie data is MERGED with localStorage data — cookie wins for keys it has, localStorage
// fills in missing keys (notably previewCustomIcon base64, which cannot fit in a cookie).
async function submitFormToLineProperties(formElement) {
    const cookieFormData = getCookie('formData');
    const localStorageFormData = localStorage.getItem('formData')
        ? JSON.parse(localStorage.getItem('formData'))
        : null;

    const formData = (cookieFormData || localStorageFormData)
        ? { ...(localStorageFormData || {}), ...(cookieFormData || {}) }
        : null;

    if (formElement) {
        const placementOptionInput = document.getElementById('property-placement-option');
        if (placementOptionInput) placementOptionInput.value = "";

        const nameInput = document.getElementById('property-name');
        if (nameInput) nameInput.value = "";

        const designationInput = document.getElementById('property-designation');
        if (designationInput) designationInput.value = "";

        const topNameInput = document.getElementById('property-top-name');
        if (topNameInput) topNameInput.value = "";

        const topDesignationInput = document.getElementById('property-top-designation');
        if (topDesignationInput) topDesignationInput.value = "";

        const bottomNameInput = document.getElementById('property-bottom-name');
        if (bottomNameInput) bottomNameInput.value = "";

        const colorInput = document.getElementById('property-color');
        if (colorInput) colorInput.value = "";

        const fontInput = document.getElementById('property-font');
        if (fontInput) fontInput.value = "";

        const formNameInput = document.getElementById('property-formName');
        if (formNameInput) formNameInput.value = "";

        const iconPlacementInput = document.getElementById('property-iconplacementValue');
        if (iconPlacementInput) iconPlacementInput.value = "";

        const textPlacementInputReset = document.getElementById('property-textplacementValue');
        if (textPlacementInputReset) textPlacementInputReset.value = "";

        if (formElement.querySelector('[name="properties[Icon]"]')) {
            formElement.querySelector('[name="properties[Icon]"]').remove();
        }
        if (formElement.querySelector('[name="properties[Icon Type]"]')) {
            formElement.querySelector('[name="properties[Icon Type]"]').remove();
        }
        // Only remove dynamically-created duplicate file inputs — never the persistent
        // #property-custom-icon input from buy-buttons.liquid, which the rest of the
        // personalization flow (and product-form.js) looks up via getElementById and
        // reuses on every subsequent personalization. Removing it permanently broke
        // every later Icon/Name-and-Icon submission and add-to-cart.
        formElement.querySelectorAll('[name="properties[Custom Icon]"]').forEach((el) => {
            if (el.id !== 'property-custom-icon') {
                el.remove();
            }
        });
    }

    if (formData) {
        if (formData.formName === 'Name' || formData.formName === 'Name and Icon') {
            const isEmbroideryFlow = 'placementOption' in formData;

            if (isEmbroideryFlow) {
                const placementOptionInput = document.getElementById('property-placement-option');
                if (placementOptionInput) {
                    placementOptionInput.value = formData.placementOption || '';
                }
                if (formData.topName) {
                    const topNameInput = document.getElementById('property-top-name');
                    if (topNameInput) topNameInput.value = formData.topName;
                }
                if (formData.topDesignation) {
                    const topDesignationInput = document.getElementById('property-top-designation');
                    if (topDesignationInput) topDesignationInput.value = formData.topDesignation;
                }
                if (formData.bottomName) {
                    const bottomNameInput = document.getElementById('property-bottom-name');
                    if (bottomNameInput) bottomNameInput.value = formData.bottomName;
                }
            } else {
                if (formData.name) {
                    const nameInput = document.getElementById('property-name');
                    if (nameInput) nameInput.value = formData.name;
                }
                if (formData.designation) {
                    const designationInput = document.getElementById('property-designation');
                    if (designationInput) designationInput.value = formData.designation;
                }
            }

            if (formData.color) {
                const colorInput = document.getElementById('property-color');
                if (colorInput) colorInput.value = formData.color;
            }

            if (formData.font) {
                const fontInput = document.getElementById('property-font');
                if (fontInput) fontInput.value = formData.font;
            }

            if (formData.textplacementValue) {
                const placementInput = document.getElementById('property-textplacementValue');
                if (placementInput) placementInput.value = formData.textplacementValue;
            }

            if (formData.specialRequest) {
                let specialRequestInput = document.getElementById('property-special-request');
                if (!specialRequestInput) {
                    specialRequestInput = document.createElement('input');
                    specialRequestInput.type = 'hidden';
                    specialRequestInput.id = 'property-special-request';
                    specialRequestInput.name = 'properties[Special Request]';
                    specialRequestInput.setAttribute('form', formElement.dataset.productForm);
                    formElement.appendChild(specialRequestInput);
                }
                specialRequestInput.value = formData.specialRequest;
            } else {
                const specialRequestInput = document.getElementById('property-special-request');
                if (specialRequestInput) {
                    specialRequestInput.remove();
                }
            }
        }

        if (formData.formName) {
            const formNameInput = document.getElementById('property-formName');
            if (formNameInput) {
                formNameInput.value = formData.formName;
            }
        }

        if (formData.formName === 'Icon' || formData.formName === 'Name and Icon') {
            if (formData.iconplacementValue) {
                const iconPlacementInput = document.getElementById('property-iconplacementValue');
                if (iconPlacementInput) {
                    iconPlacementInput.value = formData.iconplacementValue;
                }
            }

            if (formData.icon) {
                try {
                    const iconPath = `https://cdn.shopify.com/s/files/1/0869/7551/2851/${formData.icon}`;
                    const file = await urlToFile(iconPath, 'icon.png', 'image/png');

                    const input = document.createElement('input');
                    input.type = 'file';
                    input.name = 'properties[Icon]';
                    input.classList.add('tw-hidden');
                    input.setAttribute('form', formElement.dataset.productForm);
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);
                    input.files = dataTransfer.files;
                    formElement.appendChild(input);

                    const input2 = document.createElement('input');
                    input2.type = 'hidden';
                    input2.name = 'properties[Icon Type]';
                    input2.setAttribute('form', formElement.dataset.productForm);
                    let iconName = formData.icon
                        .replace("files/", "")
                        .replace(".png", "")
                        .replace(".svg", "")
                        .replace(".jpg", "")
                        .replace(".jpeg", "");
                    input2.value = capitalizeFirstLetter(iconName);

                    const iconPlacementInput = document.getElementById('property-iconplacementValue');
                    if (iconPlacementInput) {
                        iconPlacementInput.parentNode.insertBefore(input2, iconPlacementInput);
                    }
                } catch (error) {
                    console.error("Error processing icon:", error);
                }
            }

            // NOTE: gated on the merged `formData.customIcon` (cookie wins over localStorage),
            // never on raw `localStorageFormData` directly — localStorage isn't updated when the
            // user switches back to a preset icon (only the cookie is), so checking it directly
            // kept treating a stale previous custom-icon upload as still active and submitted a
            // second, conflicting Icon Type + Custom Icon property alongside the preset icon.
            if (formData.customIcon) {
                try {
                    const input2 = document.createElement('input');
                    input2.type = 'hidden';
                    input2.name = 'properties[Icon Type]';
                    input2.setAttribute('form', formElement.dataset.productForm);
                    input2.value = `Custom`;

                    const iconPlacementInput = document.getElementById('property-iconplacementValue');
                    if (iconPlacementInput) {
                        iconPlacementInput.parentNode.insertBefore(input2, iconPlacementInput);
                    }

                    if (formData.previewCustomIcon) {
                        const fileName = formData.customIcon.split('\\').pop();
                        const customIconFile = dataURLtoFile(formData.previewCustomIcon, fileName);

                        const customIconInput = document.createElement('input');
                        customIconInput.type = 'file';
                        customIconInput.name = 'properties[Custom Icon]';
                        customIconInput.classList.add('tw-hidden');
                        customIconInput.setAttribute('form', formElement.dataset.productForm);

                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(customIconFile);
                        customIconInput.files = dataTransfer.files;

                        formElement.appendChild(customIconInput);
                    }
                    else {
                        const fileInput = document.getElementById('property-custom-icon');
                        if (fileInput && fileInput.files.length > 0) {
                            const customIconInput = document.createElement('input');
                            customIconInput.type = 'file';
                            customIconInput.name = 'properties[Custom Icon]';
                            customIconInput.classList.add('tw-hidden');
                            customIconInput.setAttribute('form', formElement.dataset.productForm);

                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(fileInput.files[0]);
                            customIconInput.files = dataTransfer.files;

                            formElement.appendChild(customIconInput);
                        }
                    }
                } catch (error) {
                    console.error("Error processing custom icon:", error);
                }
            }
        }
    }
}

function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

async function urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], filename, { type: mimeType });
    return file;
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

// removeAllInputs clears whichever hidden inputs exist — safe for both flows.
function removeAllInputs() {
    const formElement = document.querySelector('[data-product-form]');
    formElement.querySelector('[name="properties[mainProduct]"]').value = "";
    formElement.querySelector('[name="properties[uniqueId]"]').value = "";
    formElement.querySelector('#property-name') && (formElement.querySelector('#property-name').value = "");
    formElement.querySelector('#property-designation') && (formElement.querySelector('#property-designation').value = "");
    formElement.querySelector('#property-placement-option') && (formElement.querySelector('#property-placement-option').value = "");
    formElement.querySelector('#property-top-name') && (formElement.querySelector('#property-top-name').value = "");
    formElement.querySelector('#property-top-designation') && (formElement.querySelector('#property-top-designation').value = "");
    formElement.querySelector('#property-bottom-name') && (formElement.querySelector('#property-bottom-name').value = "");
    formElement.querySelector('#property-color').value = "";
    formElement.querySelector('#property-font').value = "";
    formElement.querySelector('#property-formName').value = "";
    formElement.querySelector('#property-textplacementValue') && (formElement.querySelector('#property-textplacementValue').value = "");
    formElement.querySelector('#property-iconplacementValue').value = "";
    if (formElement.querySelector('[name="properties[Icon]"]')) {
        formElement.querySelector('[name="properties[Icon]"]').remove();
    }
    if (formElement.querySelector('[name="properties[Custom Icon]"]')) {
        formElement.querySelector('[name="properties[Custom Icon]"]').value = '';
    }

    removeCookie('formData');
    removeCookie('color-name');
    localStorage.removeItem('formData');
}

// bundlePersonalization: 'placementOption' presence picks placement-aware datasets
// (Top&Bottom pricing tier) vs the standard single-placement datasets.
//
// Cookie data is MERGED with localStorage data so we still get full formData even when the
// cookie write was skipped or truncated (e.g. base64 payload).
async function bundlePersonalization(element) {
    const cookieFormData = getCookie('formData');
    const localStorageFormData = localStorage.getItem('formData')
        ? JSON.parse(localStorage.getItem('formData'))
        : null;

    let formData = (cookieFormData || localStorageFormData)
        ? { ...(localStorageFormData || {}), ...(cookieFormData || {}) }
        : null;

    console.log('[Personalization Debug] bundlePersonalization() start', {
        cookieFormData,
        localStorageFormData,
        mergedFormData: formData,
        productMetafields: {
            personalizeName: element.dataset.personalizeName,
            personalizeTopBottom: element.dataset.personalizeTopBottom,
            personalizeIcon: element.dataset.personalizeIcon,
            personalizeCustomIcon: element.dataset.personalizeCustomIcon,
            personalizeNameIcon: element.dataset.personalizeNameIcon,
            personalizeCustomNameIcon: element.dataset.personalizeCustomNameIcon,
            personalizeNameIconTopBottom: element.dataset.personalizeNameIconTopBottom,
            personalizeCustomNameIconTopBottom: element.dataset.personalizeCustomNameIconTopBottom,
        }
    });

    const mainProductId = element.dataset.productId;
    const mainSubItemId = element.dataset.productVariantId;
    const uniqueId = getUniqueId();

    const mainProductInput = document.querySelector(`[name="properties[mainProduct]"]`);
    const uniqueIdInput = document.querySelector(`[name="properties[uniqueId]"]`);

    if (mainProductInput) {
        mainProductInput.value = "";
        mainProductInput.value = mainProductId;
    }

    if (uniqueIdInput) {
        uniqueIdInput.value = "";
        uniqueIdInput.value = uniqueId;
    }

    let bundleBody = {
        items: [],
        sections: ["cart-drawer", "cart-icon-bubble"],
        section_url: `${window.location.pathname}`,
    };

    if (formData) {
        const formName = formData.formName;

        const getPersonalizeType = () => {
            switch (formName) {
                case 'Name': {
                    if ('placementOption' in formData) {
                        const placementOption = formData.placementOption || 'top-bottom';
                        if (placementOption === 'top-bottom') {
                            return JSON.parse(element.dataset.personalizeTopBottom);
                        }
                    }
                    return JSON.parse(element.dataset.personalizeName);
                }
                case 'Icon':
                    return formData.icon
                        ? JSON.parse(element.dataset.personalizeIcon)
                        : JSON.parse(element.dataset.personalizeCustomIcon);
                case 'Name and Icon': {
                    if ('placementOption' in formData) {
                        const placementOption = formData.placementOption || 'top-bottom';
                        if (placementOption === 'top-bottom') {
                            return formData.icon
                                ? JSON.parse(element.dataset.personalizeNameIconTopBottom)
                                : JSON.parse(element.dataset.personalizeCustomNameIconTopBottom);
                        }
                    }
                    return formData.icon
                        ? JSON.parse(element.dataset.personalizeNameIcon)
                        : JSON.parse(element.dataset.personalizeCustomNameIcon);
                }
                default:
                    return null;
            }
        };

        const personalizeType = getPersonalizeType();

        console.log('[Personalization Debug] getPersonalizeType() resolved', {
            formName,
            placementOption: formData.placementOption,
            iconMode: formData.icon ? 'preset' : 'custom',
            personalizeType
        });

        if (personalizeType) {
            personalizeType.variants.forEach((variant) => {
                const itemProperties = {
                    mainProductId: mainProductId,
                    uniqueSubId: uniqueId
                };

                if (formName === 'Name') {
                    itemProperties.productType = true;
                }

                if (formName === 'Icon') {
                    const customIconInput = document.querySelector('#property-custom-icon');
                    if (customIconInput) {
                        itemProperties.customIcon = customIconInput.value;
                    }
                }

                if (formName === 'Name and Icon') {
                    itemProperties.productType = true;
                }

                bundleBody.items.push({
                    id: JSON.stringify(variant.id),
                    quantity: 1,
                    properties: itemProperties
                });
            });
        } else {
            // The product's personalize_* metafield for this exact combination (form type +
            // placement option + custom-vs-preset icon) is missing/blank in Shopify admin, so
            // there's no bundle variant to add. Flag it so product-form.js can refuse to submit
            // a broken request (no `id`) instead of letting Shopify return a raw 400 for "items".
            bundleBody.error = 'missing_personalize_metafield';
            console.error(
                `Personalization bundle metafield missing for formName="${formName}", ` +
                `placementOption="${formData.placementOption || 'n/a'}", ` +
                `icon="${formData.icon ? 'preset' : 'custom'}". Check this product's personalize_* metafields in Shopify admin.`
            );
        }
    } else {
        bundleBody.items.push({
            id: mainSubItemId,
            quantity: 1,
            properties: {
                mainProduct: mainProductId,
            },
        });
    }

    console.log('[Personalization Debug] final bundleBody', bundleBody);

    try {
        localStorage.setItem('bundleBody', JSON.stringify(bundleBody));
        setCookie('bundleBody', bundleBody);
    } catch (error) {
        console.error('Error storing bundle body:', error);
    }

    return bundleBody;
}

function getUniqueId() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}

if (typeof window !== 'undefined') {
    window.bundlePersonalization = bundlePersonalization;
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

document.addEventListener('DOMContentLoaded', () => {
    if (localStorage.getItem('formData')) {
        localStorage.removeItem('formData');
        checkLocalStorage();
    }
    if (localStorage.getItem('bundleBody')) {
        localStorage.removeItem('bundleBody');
        checkLocalStorage();
    }

    getProductSKU();
});

// getProductSKU uses the superset maps (includes Scrub Cap, extra colors/styles from the caps file)
function getProductSKU() {
    const productName = document.querySelector('.product__title').innerText.trim();

    let topSize = '';
    let bottomSize = '';

    const productCodeMap = {
        'Scrub Set': 'SS',
        'Scrub Cap': 'SC',   // must come before 'Scrub'
        'Scrubs': 'SS',
        'Scrub': 'SS',
        'Lab Coat': 'LC'
    };

    const genderMap = { 'Men': 'M', 'Women': 'W' };

    const styleMap = {
        'Technical': 'T', 'Util Tech': 'UT', 'Eco Tech 11': 'E11', 'Elite Pro': 'EP', 'Eco Tech 5': 'E5', 'Lifestyle': 'L', 'Effortless': 'E'
    };
    const colorMap = {
        'Black': 'BLK', 'Burgundy': 'BUR', 'Forest Green': 'FGN', 'Caribbean Blue': 'CBU',
        'Royal Navy': 'RNY', 'Midnight Black': 'MBL', 'Midnight Green': 'MGN', 'Midnight Blue': 'MBU',
        'Lavender': 'LAV', 'Terra Pink': 'TPK', 'Slate Grey': 'SGY', 'Ceil Blue': 'CLU',
        'Electric Blue': 'EBU', 'Plum': 'PLM', 'Galaxy': 'GXY', 'Hunter Green': 'HTR', 'Espresso': 'ESP', 'Midnight Teal': 'TEL',
        'Avocado': 'AVO', 'Gym': 'GYM', 'Jordans': 'JOR', 'Coffee': 'COF', 'Music': 'MUS' , 'Tuscan Olive': 'OLV'
    };

    const embMap = { 'Mandarin': 'MDN' };
    let emb = '';
    for (let key in embMap) {
        if (productName.includes(key)) {
            emb = embMap[key];
            break;
        }
    }

    document.querySelectorAll('.active--varaint').forEach(variant => {
        if (variant.dataset.option.includes('top')) {
            topSize = variant.innerText.trim();
        }
        else if (variant.dataset.option.includes('bottom')) {
            bottomSize = variant.innerText.trim();
        }
    });

    let productCode = '';
    for (let key in productCodeMap) {
        if (productName.includes(key)) {
            productCode = productCodeMap[key];
            break;
        }
    }

    let gender = '';
    for (let key in genderMap) {
        if (productName.includes(key)) {
            gender = genderMap[key];
            break;
        }
    }

    let color = '';
    for (let key in colorMap) {
        if (productName.includes(key)) {
            color = colorMap[key];
            break;
        }
    }

    let style = '';
    for (let key in styleMap) {
        if (productName.includes(key)) {
            style = styleMap[key];
            break;
        }
    }

    const skuParts = [productCode, gender, emb, style, color, topSize, bottomSize];
    const sku = skuParts.filter(part => part).join('-');

    const skuInput = document.querySelector('input[name="properties[SKU]"]');
    if (skuInput) {
        skuInput.value = "";
        skuInput.value = sku;
    }
}


document.addEventListener("DOMContentLoaded", () => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasColorParam = urlParams.has('variant') || urlParams.has('color');

    if (hasColorParam) {
        removeCookie('formData');
        removeCookie('color-name');
        removeCookie('bundleBody');
        localStorage.removeItem('formData');
        localStorage.removeItem('bundleBody');
    }

    if (!window.uploadEventListenersAttached) {
        let fileInput = document.getElementById('property-custom-icon');

        if (!fileInput) {
            fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.id = 'property-custom-icon';
            fileInput.accept = 'image/*';
            fileInput.classList.add('tw-w-[0.1rem]', 'tw-h-[0.1rem]', 'tw-invisible');
            document.body.appendChild(fileInput);
        }

        const secondaryCustomIcon = document.querySelector('#secondary-property-custom-icon');
        const tertiaryCustomIcon = document.querySelector('#tertiary-property-custom-icon');

        if (secondaryCustomIcon) {
            secondaryCustomIcon.addEventListener('click', (e) => {
                e.preventDefault();

                const iconLabels = document.querySelectorAll('icon-picker label');
                if (iconLabels) {
                    iconLabels.forEach(label => {
                        if (label) {
                            label.style.border = '0';
                            label.style.padding = '0';
                            label.style.width = '3.6rem';
                            label.style.height = '3.6rem';
                            label.style.outline = 'none';
                        }
                    });
                }

                const iconInputs = document.querySelectorAll('.icon-input');
                if (iconInputs) {
                    iconInputs.forEach(input => {
                        if (input) input.checked = false;
                    });
                }

                const selectedIconSpan = document.getElementById('selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = '';
                }

                fileInput.accept = "image/*";
                fileInput.setAttribute('data-active-form', 'secondary');

                if (fileInput) {
                    fileInput.click();
                }
            });
        }

        if (tertiaryCustomIcon) {
            tertiaryCustomIcon.addEventListener('click', (e) => {
                e.preventDefault();

                const tertiaryIconLabels = document.querySelectorAll('tertiary-icon-picker label');
                if (tertiaryIconLabels) {
                    tertiaryIconLabels.forEach(label => {
                        if (label) {
                            label.style.border = '0';
                            label.style.padding = '0';
                            label.style.width = '3.6rem';
                            label.style.height = '3.6rem';
                            label.style.outline = 'none';
                        }
                    });
                }

                const tertiaryIconInputs = document.querySelectorAll('.tertiary-icon-input');
                if (tertiaryIconInputs) {
                    tertiaryIconInputs.forEach(input => {
                        if (input) input.checked = false;
                    });
                }

                const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = '';
                }

                fileInput.setAttribute('data-active-form', 'tertiary');

                if (fileInput) {
                    fileInput.click();
                }
            });
        }

        if (fileInput) {
            const oldChangeHandler = fileInput._changeHandler;
            if (oldChangeHandler) {
                try {
                    fileInput.removeEventListener('change', oldChangeHandler);
                } catch (e) {
                    console.error("Error removing old event listener:", e);
                }
            }

            const newChangeHandler = (e) => {
                const activeForm = fileInput.getAttribute('data-active-form');

                if (!e.target.files || e.target.files.length === 0) {
                    fileInput.value = '';

                    if (activeForm === 'secondary') {
                        const firstIcon = document.getElementById('icon-1');
                        if (firstIcon) {
                            firstIcon.checked = true;
                            const changeEvent = new Event('change', { bubbles: true });
                            firstIcon.dispatchEvent(changeEvent);

                            const selectedIconSpan = document.getElementById('selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = firstIcon.value;
                            }

                            updatePrice({ target: { type: 'radio' } }, 'secondary');
                        }
                    } else if (activeForm === 'tertiary') {
                        const firstIcon = document.getElementById('tertiary-icon-1');
                        if (firstIcon) {
                            firstIcon.checked = true;
                            const changeEvent = new Event('change', { bubbles: true });
                            firstIcon.dispatchEvent(changeEvent);

                            const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = firstIcon.value;
                            }

                            if (window.updateTertiaryPrice) { window.updateTertiaryPrice('radio'); } else { updatePrice({ target: { type: 'radio' } }, 'tertiary'); }
                        }
                    }

                    let uploadLabel, fileDisclaimer, labelAbbr;
                    if (activeForm === 'secondary') {
                        uploadLabel = document.getElementById('upload-label');
                        fileDisclaimer = document.getElementById('file-disclaimer');
                        labelAbbr = document.getElementById('label-abbr');
                    } else if (activeForm === 'tertiary') {
                        const tertiaryForm = document.querySelector('tertiary-form');
                        if (tertiaryForm) {
                            uploadLabel = tertiaryForm.querySelector('#upload-label');
                            fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                            labelAbbr = tertiaryForm.querySelector('#label-abbr');
                        }
                    }

                    if (uploadLabel && fileDisclaimer && labelAbbr) {
                        const originalLabelValue = uploadLabel.dataset.labelValue;
                        uploadLabel.textContent = originalLabelValue;
                        labelAbbr.title = '';
                        fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                        fileDisclaimer.style.fontWeight = 'normal';
                        fileDisclaimer.style.color = '';
                    }

                    return;
                }

                if (!validateFileInput(fileInput)) {
                    fileInput.value = '';

                    if (activeForm === 'secondary') {
                        const firstIcon = document.getElementById('icon-1');
                        if (firstIcon) {
                            firstIcon.checked = true;
                            const changeEvent = new Event('change', { bubbles: true });
                            firstIcon.dispatchEvent(changeEvent);

                            const selectedIconSpan = document.getElementById('selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = firstIcon.value;
                            }

                            updatePrice({ target: { type: 'radio' } }, 'secondary');
                        }
                    } else if (activeForm === 'tertiary') {
                        const firstIcon = document.getElementById('tertiary-icon-1');
                        if (firstIcon) {
                            firstIcon.checked = true;
                            const changeEvent = new Event('change', { bubbles: true });
                            firstIcon.dispatchEvent(changeEvent);

                            const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = firstIcon.value;
                            }

                            if (window.updateTertiaryPrice) { window.updateTertiaryPrice('radio'); } else { updatePrice({ target: { type: 'radio' } }, 'tertiary'); }
                        }
                    }

                    let uploadLabel, fileDisclaimer, labelAbbr;
                    if (activeForm === 'secondary') {
                        uploadLabel = document.getElementById('upload-label');
                        fileDisclaimer = document.getElementById('file-disclaimer');
                        labelAbbr = document.getElementById('label-abbr');
                    } else if (activeForm === 'tertiary') {
                        const tertiaryForm = document.querySelector('tertiary-form');
                        if (tertiaryForm) {
                            uploadLabel = tertiaryForm.querySelector('#upload-label');
                            fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                            labelAbbr = tertiaryForm.querySelector('#label-abbr');
                        }
                    }

                    if (fileDisclaimer) {
                        fileDisclaimer.textContent = 'Invalid file. Please upload an image file under 10MB.';
                        fileDisclaimer.style.color = '#ff0000';
                        fileDisclaimer.style.fontWeight = 'bold';
                    }

                    if (uploadLabel && labelAbbr) {
                        const originalLabelValue = uploadLabel.dataset.labelValue;
                        uploadLabel.textContent = originalLabelValue;
                        labelAbbr.title = '';
                    }

                    setTimeout(() => {
                        if (fileDisclaimer) {
                            fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                            fileDisclaimer.style.color = '';
                            fileDisclaimer.style.fontWeight = 'normal';
                        }
                    }, 3000);

                    return;
                }

                const file = e.target.files[0];

                if (file) {
                    const fileName = file.name;
                    let uploadLabel, fileDisclaimer, labelAbbr;

                    try {
                        const iconError = activeForm === 'secondary'
                            ? document.querySelector("#secondary-icon-error")
                            : document.querySelector("#tertiary-icon-error");
                        if (iconError) {
                            iconError.classList.add('tw-hidden');
                        }

                        if (activeForm === 'secondary') {
                            updatePrice(e, 'secondary');

                            uploadLabel = document.getElementById('upload-label');
                            fileDisclaimer = document.getElementById('file-disclaimer');
                            labelAbbr = document.getElementById('label-abbr');

                            const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                            if (formData) {
                                formData.icon = '';
                                localStorage.setItem('formData', JSON.stringify(formData));
                            }

                            const selectedIconSpan = document.getElementById('selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = 'Custom Icon';
                            }

                        } else if (activeForm === 'tertiary') {
                            if (window.updateTertiaryPrice) { window.updateTertiaryPrice('file'); } else { updatePrice(e, 'tertiary'); }

                            const tertiaryForm = document.querySelector('tertiary-form');
                            if (tertiaryForm) {
                                uploadLabel = tertiaryForm.querySelector('#upload-label');
                                fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                                labelAbbr = tertiaryForm.querySelector('#label-abbr');
                            }

                            const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                            if (formData) {
                                formData.icon = '';
                                localStorage.setItem('formData', JSON.stringify(formData));
                            }

                            const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                            if (selectedIconSpan) {
                                selectedIconSpan.textContent = 'Custom Icon';
                            }
                        }

                        if (uploadLabel && fileDisclaimer && labelAbbr) {
                            uploadLabel.textContent = fileName;
                            labelAbbr.title = fileName;
                            fileDisclaimer.textContent = 'File Uploaded Successfully';
                            fileDisclaimer.style.fontWeight = 'bold';
                            fileDisclaimer.style.color = '#008000';
                        }

                        if (fileDisclaimer && file.size) {
                            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                            setTimeout(() => {
                                if (fileDisclaimer) {
                                    fileDisclaimer.textContent = `File Uploaded Successfully (${fileSizeMB}MB)`;
                                }
                            }, 500);
                        }

                    } catch (error) {
                        console.error("Error handling file change:", error);

                        if (fileDisclaimer) {
                            fileDisclaimer.textContent = 'Error processing file. Please try again.';
                            fileDisclaimer.style.color = '#ff0000';
                            fileDisclaimer.style.fontWeight = 'bold';
                        }

                        fileInput.value = '';

                        if (activeForm === 'secondary') {
                            const firstIcon = document.getElementById('icon-1');
                            if (firstIcon) {
                                firstIcon.checked = true;
                                firstIcon.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        } else if (activeForm === 'tertiary') {
                            const firstIcon = document.getElementById('tertiary-icon-1');
                            if (firstIcon) {
                                firstIcon.checked = true;
                                firstIcon.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
                    }
                }
            };

            fileInput._changeHandler = newChangeHandler;
            fileInput.addEventListener('change', newChangeHandler);
        }

        window.uploadEventListenersAttached = true;
    }

    if (!getCookie('formData') && !localStorage.getItem('formData')) {
        removeCookie('bundleBody');
        localStorage.removeItem('bundleBody');
    }

    const tabs = document.querySelectorAll("[id^=tab-]");
    const forms = {
        "tab-name": document.getElementById("form-primary"),
        "tab-icon": document.getElementById("form-secondary"),
        "tab-both": document.getElementById("form-tertiary"),
    };

    if (forms["tab-name"]) {
        forms["tab-name"].classList.remove("tw-hidden");
        const tabName = document.getElementById("tab-name");
        if (tabName) {
            tabName.classList.remove("color_E6E6E6");
            tabName.classList.add("color_C8C8CA");
        }
    }

    if (tabs && tabs.length > 0) {
        tabs.forEach((tab) => {
            if (tab) {
                tab.addEventListener("click", (e) => {
                    Object.values(forms).forEach(form => {
                        if (form) form.classList.add("tw-hidden");
                    });

                    const currentForm = forms[tab.id];
                    if (currentForm) {
                        currentForm.classList.remove("tw-hidden");
                        currentForm.classList.add("tw-transition-opacity", "tw-duration-300", "tw-opacity-0");
                        currentForm.offsetHeight;
                        currentForm.classList.remove("tw-opacity-0");
                        currentForm.classList.add("tw-opacity-100");

                        if (currentForm.id === 'form-secondary') {
                            const rangePrice = document.getElementById('secondary-form-price');
                            if (rangePrice) rangePrice.textContent = rangePrice.dataset.formPrice;
                        }

                        if (currentForm.id === 'form-tertiary') {
                            const rangePrice = document.getElementById('tertiary-form-price');
                            if (rangePrice) rangePrice.textContent = rangePrice.dataset.formPrice;
                        }
                    }

                    tabs.forEach(tab => {
                        if (tab) {
                            tab.classList.remove("color_C8C8CA");
                            tab.classList.add("color_E6E6E6");
                        }
                    });

                    tab.classList.add("color_C8C8CA");
                    tab.classList.remove("color_E6E6E6");
                });
            }
        });
    }

    // Global blur handlers — same discriminator pattern as the early DOMContentLoaded above
    const topNameFieldGlobal = document.getElementById('top-name');
    const bottomNameFieldGlobal = document.getElementById('bottom-name');
    const primaryNameFieldGlobal = document.querySelector('.primary_name');
    const tertiaryName = document.querySelector('.tertiary_name');

    if (topNameFieldGlobal) {
        topNameFieldGlobal.addEventListener('blur', () => {
            const placementSelect = document.getElementById('text-placement-select');
            if (placementSelect && placementSelect.value === 'bottom-only') return;
            const errorMessage = document.querySelector('#top-name-error');
            if (topNameFieldGlobal.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    } else if (primaryNameFieldGlobal) {
        primaryNameFieldGlobal.addEventListener('blur', () => {
            const errorMessage = document.querySelector('#primary-error-message');
            if (primaryNameFieldGlobal.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    }

    if (bottomNameFieldGlobal) {
        bottomNameFieldGlobal.addEventListener('blur', () => {
            const placementSelect = document.getElementById('text-placement-select');
            if (placementSelect && placementSelect.value === 'top-only') return;
            const errorMessage = document.querySelector('#bottom-name-error');
            if (bottomNameFieldGlobal.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    }

    if (tertiaryName) {
        tertiaryName.addEventListener('blur', () => {
            const placementSelect = document.getElementById('tertiary-text-placement-select');
            if (placementSelect && placementSelect.value === 'bottom-only') return;
            const errorMessage = document.querySelector('#tertiary-top-name-error') || document.querySelector('#tertiary-error-message');
            if (tertiaryName.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    }

    function initializeColorSwatches() {
        const coreColorInputs = document.querySelectorAll('#core-color-swatches input[type="radio"]');
        const limitedColorInputs = document.querySelectorAll('#limited-color-swatches input[type="radio"]');

        function updatePreviewBackgroundColor(colorCode) {
            const previewBackgrounds = [
                document.getElementById('preview-primary-background'),
                document.querySelector('.tertiary_form_preview #preview-primary-background'),
                document.getElementById('preview-bottom-background'),
                document.querySelector('.tertiary_form_preview #preview-bottom-background'),
                document.getElementById('icon-holder'),
                document.querySelector('.tertiary_form_preview #icon-holder')
            ];

            previewBackgrounds.forEach(element => {
                if (element) {
                    element.style.backgroundColor = colorCode;
                }
            });

            try {
                localStorage.setItem('selected-preview-color', colorCode);
                setCookie('selected-preview-color', colorCode);
            } catch (e) {
                console.error("Error storing color:", e);
            }
        }

        if (coreColorInputs && coreColorInputs.length > 0) {
            coreColorInputs.forEach(input => {
                if (input) {
                    input.addEventListener('change', () => {
                        if (input.checked) {
                            const hasPersonalization = getCookie('formData') || localStorage.getItem('formData');

                            if (hasPersonalization) {
                                removeCookie('formData');
                                removeCookie('color-name');
                                removeCookie('bundleBody');
                                localStorage.removeItem('formData');
                                localStorage.removeItem('bundleBody');

                                checkLocalStorage();
                                removeAllInputs();
                            }

                            const colorCode = input.getAttribute('data-bg-color-preview');
                            if (colorCode) {
                                updatePreviewBackgroundColor(colorCode);
                            }
                        }
                    });

                    if (input.checked || input.classList.contains('checked__color')) {
                        const colorCode = input.getAttribute('data-bg-color-preview');
                        if (colorCode) {
                            updatePreviewBackgroundColor(colorCode);
                        }
                    }
                }
            });
        }

        if (limitedColorInputs && limitedColorInputs.length > 0) {
            limitedColorInputs.forEach(input => {
                if (input) {
                    input.addEventListener('change', () => {
                        if (input.checked) {
                            const hasPersonalization = getCookie('formData') || localStorage.getItem('formData');

                            if (hasPersonalization) {
                                removeCookie('formData');
                                removeCookie('color-name');
                                removeCookie('bundleBody');
                                localStorage.removeItem('formData');
                                localStorage.removeItem('bundleBody');

                                checkLocalStorage();
                                removeAllInputs();
                            }

                            const colorCode = input.getAttribute('data-bg-color-preview');
                            if (colorCode) {
                                updatePreviewBackgroundColor(colorCode);
                            }
                        }
                    });

                    if (input.checked || input.classList.contains('checked__color')) {
                        const colorCode = input.getAttribute('data-bg-color-preview');
                        if (colorCode) {
                            updatePreviewBackgroundColor(colorCode);
                        }
                    }
                }
            });
        }
    }

    function patchEventListeners() {
        setTimeout(() => {
            const fileInputs = document.querySelectorAll('input[type="file"]');
            fileInputs.forEach(input => {
                if (input && !input._safetyPatched) {
                    const originalAddEventListener = input.addEventListener;
                    const originalRemoveEventListener = input.removeEventListener;

                    input.addEventListener = function (type, listener, options) {
                        this._listeners = this._listeners || {};
                        this._listeners[type] = this._listeners[type] || [];
                        this._listeners[type].push(listener);
                        return originalAddEventListener.call(this, type, listener, options);
                    };

                    input.removeEventListener = function (type, listener, options) {
                        if (!this._listeners || !this._listeners[type]) {
                            return;
                        }
                        const index = this._listeners[type].indexOf(listener);
                        if (index !== -1) {
                            this._listeners[type].splice(index, 1);
                        }
                        try {
                            return originalRemoveEventListener.call(this, type, listener, options);
                        } catch (e) {
                            console.warn("Safe ignore: removeEventListener error prevented", e);
                        }
                    };

                    input._safetyPatched = true;
                }
            });
        }, 500);
    }

    patchEventListeners();
    initializeColorSwatches();
    checkLocalStorage();

    const formElement = document.querySelector('[data-product-form]');
    if (formElement) {
        submitFormToLineProperties(formElement);

        const bundleData = getCookie('bundleBody') || localStorage.getItem('bundleBody');
        if (bundleData) {
            bundlePersonalization(formElement);
        }
    }

    getProductSKU();
});